/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Vee - Traveler - API
 * Descripción
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "react-query";
import type {
  AcceptedTyCVm,
  AccessToken,
  ActivityAddressVm,
  ActivityAudienceActivePriceVm,
  ActivityAvailableTariffRequest,
  ActivityBasicInfoVm,
  ActivityBySlugDto,
  ActivityDetailGeoSearch,
  ActivityDetailVm,
  ActivityLanguage,
  ActivityMobilityVm,
  ActivityStartDateEndDateVm,
  ActivityTag,
  ActivityTariffAvailability,
  ActivityTermsAndConditionsVm,
  AddActivityToFavoriteListRequest,
  AddAirshipChannelDto,
  AnonymousTokenDto,
  AvailabilityDatesVm,
  AvailabilityHoursVm,
  CardDetail,
  CashbackCouponRequest,
  CashbackCouponVm,
  Category,
  ChangePassword,
  ChangeReservationDateRequest,
  CityDto,
  Community,
  ConfirmForgotPassword,
  CreateFavoriteTravelerActivityListRequest,
  CreateGroupReservationRequest,
  CreateIndividualDetailedReservationRequest,
  CreateIndividualReservationRequest,
  CustomField,
  CustomSchedule,
  DeleteAccountDto,
  DraftConfirmationPaymentRequest,
  DraftConfirmationVm,
  FavoriteTravelerActivity,
  FindByLocationAndDaysParams,
  FindByLocationParams,
  FindByLocationV2Params,
  FindCityByNameParams,
  FindCommunityByNameParams,
  FindProvinceByNameParams,
  ForgotPassword,
  GetAllActivityInfoParams,
  GetAppleLoginUrlParams,
  GetChallengeParams,
  GetCommentsParams,
  GetFacebookLoginUrlParams,
  GetFavoriteActivitiesFromListWithPriceParams,
  GetFavoriteTravelerActivityListParams,
  GetFavoriteTravelerActivityParams,
  GetGoogleLoginUrlParams,
  GetHistoryParams,
  GetReservationsParams,
  GetTravelerAirshipMessagesParams,
  GroupDraftRequest,
  IndividualDetailedDraftRequest,
  IndividualDraftRequest,
  InvoiceRequest,
  LoginWithAppleTokenRequest,
  LoginWithFacebookTokenRequest,
  LoginWithGoogleTokenRequest,
  LogoutDto,
  PageVmActivityDetailGeoSearch,
  PageVmActivitySearchVm,
  PageVmAirshipMessage,
  PageVmCashbackHistoryVm,
  PageVmChallengeVm,
  PageVmFavoriteTravelerActivityListVm,
  PageVmReservationFeedbackVm,
  PageVmReservationInfoVm,
  PaymentMethodVm,
  Province,
  ProvinceTableDto,
  RateService,
  RefreshTokenDto,
  ReleaseDraftSeatsParams,
  ReservationCreatedVm,
  ReservationFeedback,
  ReservationInfoDetailVm,
  SaveTravelerAirshipMessageRequest,
  ScheduleHoursRangeVm,
  SearchCategoryAndSubcategoryByNameParams,
  SearchCitiesByNameTermParams,
  SearchParams,
  SignIn,
  SignIn1Params,
  SignupAnonRequest,
  SignupRequest,
  Subcategory,
  Success,
  TranslateRequest,
  TranslationVm,
  TravelerVm,
  UpdateFavoriteTravelerActivityListRequest,
  UpdatePaymentMethod,
  UpdateProfileInfoRequest,
  UpdateStatusTravelerAirshipMessageRequest,
  VerifyAccount,
} from "../model";
import { instance } from "./instance";
import type { ErrorType } from "./instance";

/**
 * Obtiene las tarifas disponibles para un schedule
 * @summary getAvailableTariffByScheduleV2
 */
export const getAvailableTariffByScheduleV2 = (
  activityAvailableTariffRequest: ActivityAvailableTariffRequest,
) => {
  return instance<ActivityTariffAvailability[]>({
    url: `/api/v2/activity/schedule/tariffs`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: activityAvailableTariffRequest,
  });
};

export const getGetAvailableTariffByScheduleV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableTariffByScheduleV2>>,
    TError,
    { data: ActivityAvailableTariffRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvailableTariffByScheduleV2>>,
  TError,
  { data: ActivityAvailableTariffRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvailableTariffByScheduleV2>>,
    { data: ActivityAvailableTariffRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getAvailableTariffByScheduleV2(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvailableTariffByScheduleV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableTariffByScheduleV2>>
>;
export type GetAvailableTariffByScheduleV2MutationBody =
  ActivityAvailableTariffRequest;
export type GetAvailableTariffByScheduleV2MutationError = ErrorType<unknown>;

/**
 * @summary getAvailableTariffByScheduleV2
 */
export const useGetAvailableTariffByScheduleV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableTariffByScheduleV2>>,
    TError,
    { data: ActivityAvailableTariffRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAvailableTariffByScheduleV2>>,
  TError,
  { data: ActivityAvailableTariffRequest },
  TContext
> => {
  const mutationOptions =
    getGetAvailableTariffByScheduleV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Realiza la traducción de una lista de textp
 * @summary translate
 */
export const getTranslation = (translateRequest: TranslateRequest) => {
  return instance<TranslationVm>({
    url: `/api/v1/support/translate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: translateRequest,
  });
};

export const getGetTranslationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTranslation>>,
    TError,
    { data: TranslateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getTranslation>>,
  TError,
  { data: TranslateRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getTranslation>>,
    { data: TranslateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getTranslation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetTranslationMutationResult = NonNullable<
  Awaited<ReturnType<typeof getTranslation>>
>;
export type GetTranslationMutationBody = TranslateRequest;
export type GetTranslationMutationError = ErrorType<unknown>;

/**
 * @summary translate
 */
export const useGetTranslation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTranslation>>,
    TError,
    { data: TranslateRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof getTranslation>>,
  TError,
  { data: TranslateRequest },
  TContext
> => {
  const mutationOptions = getGetTranslationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary getGoogleLoginUrl
 */
export const getGoogleLoginUrl = (
  params?: GetGoogleLoginUrlParams,
  signal?: AbortSignal,
) => {
  return instance<string>({
    url: `/api/v1/social-login/google`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetGoogleLoginUrlQueryKey = (
  params?: GetGoogleLoginUrlParams,
) => {
  return [`/api/v1/social-login/google`, ...(params ? [params] : [])] as const;
};

export const getGetGoogleLoginUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoogleLoginUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetGoogleLoginUrlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGoogleLoginUrl>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGoogleLoginUrlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoogleLoginUrl>>
  > = ({ signal }) => getGoogleLoginUrl(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoogleLoginUrl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoogleLoginUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoogleLoginUrl>>
>;
export type GetGoogleLoginUrlQueryError = ErrorType<unknown>;

/**
 * @summary getGoogleLoginUrl
 */
export const useGetGoogleLoginUrl = <
  TData = Awaited<ReturnType<typeof getGoogleLoginUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetGoogleLoginUrlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGoogleLoginUrl>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGoogleLoginUrlQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary loginWithGoogleToken
 */
export const loginWithGoogleToken = (
  loginWithGoogleTokenRequest: LoginWithGoogleTokenRequest,
) => {
  return instance<AccessToken>({
    url: `/api/v1/social-login/google`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginWithGoogleTokenRequest,
  });
};

export const getLoginWithGoogleTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithGoogleToken>>,
    TError,
    { data: LoginWithGoogleTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginWithGoogleToken>>,
  TError,
  { data: LoginWithGoogleTokenRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginWithGoogleToken>>,
    { data: LoginWithGoogleTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return loginWithGoogleToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginWithGoogleTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginWithGoogleToken>>
>;
export type LoginWithGoogleTokenMutationBody = LoginWithGoogleTokenRequest;
export type LoginWithGoogleTokenMutationError = ErrorType<unknown>;

/**
 * @summary loginWithGoogleToken
 */
export const useLoginWithGoogleToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithGoogleToken>>,
    TError,
    { data: LoginWithGoogleTokenRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginWithGoogleToken>>,
  TError,
  { data: LoginWithGoogleTokenRequest },
  TContext
> => {
  const mutationOptions = getLoginWithGoogleTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary getFacebookLoginUrl
 */
export const getFacebookLoginUrl = (
  params?: GetFacebookLoginUrlParams,
  signal?: AbortSignal,
) => {
  return instance<string>({
    url: `/api/v1/social-login/facebook`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFacebookLoginUrlQueryKey = (
  params?: GetFacebookLoginUrlParams,
) => {
  return [
    `/api/v1/social-login/facebook`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFacebookLoginUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getFacebookLoginUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFacebookLoginUrlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFacebookLoginUrl>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFacebookLoginUrlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFacebookLoginUrl>>
  > = ({ signal }) => getFacebookLoginUrl(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFacebookLoginUrl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFacebookLoginUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFacebookLoginUrl>>
>;
export type GetFacebookLoginUrlQueryError = ErrorType<unknown>;

/**
 * @summary getFacebookLoginUrl
 */
export const useGetFacebookLoginUrl = <
  TData = Awaited<ReturnType<typeof getFacebookLoginUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFacebookLoginUrlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFacebookLoginUrl>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFacebookLoginUrlQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary loginWithFacebookToken
 */
export const loginWithFacebookToken = (
  loginWithFacebookTokenRequest: LoginWithFacebookTokenRequest,
) => {
  return instance<AccessToken>({
    url: `/api/v1/social-login/facebook`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginWithFacebookTokenRequest,
  });
};

export const getLoginWithFacebookTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithFacebookToken>>,
    TError,
    { data: LoginWithFacebookTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginWithFacebookToken>>,
  TError,
  { data: LoginWithFacebookTokenRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginWithFacebookToken>>,
    { data: LoginWithFacebookTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return loginWithFacebookToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginWithFacebookTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginWithFacebookToken>>
>;
export type LoginWithFacebookTokenMutationBody = LoginWithFacebookTokenRequest;
export type LoginWithFacebookTokenMutationError = ErrorType<unknown>;

/**
 * @summary loginWithFacebookToken
 */
export const useLoginWithFacebookToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithFacebookToken>>,
    TError,
    { data: LoginWithFacebookTokenRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginWithFacebookToken>>,
  TError,
  { data: LoginWithFacebookTokenRequest },
  TContext
> => {
  const mutationOptions = getLoginWithFacebookTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary getAppleLoginUrl
 */
export const getAppleLoginUrl = (
  params?: GetAppleLoginUrlParams,
  signal?: AbortSignal,
) => {
  return instance<string>({
    url: `/api/v1/social-login/apple`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAppleLoginUrlQueryKey = (
  params?: GetAppleLoginUrlParams,
) => {
  return [`/api/v1/social-login/apple`, ...(params ? [params] : [])] as const;
};

export const getGetAppleLoginUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppleLoginUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAppleLoginUrlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAppleLoginUrl>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAppleLoginUrlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAppleLoginUrl>>
  > = ({ signal }) => getAppleLoginUrl(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppleLoginUrl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAppleLoginUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppleLoginUrl>>
>;
export type GetAppleLoginUrlQueryError = ErrorType<unknown>;

/**
 * @summary getAppleLoginUrl
 */
export const useGetAppleLoginUrl = <
  TData = Awaited<ReturnType<typeof getAppleLoginUrl>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAppleLoginUrlParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAppleLoginUrl>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAppleLoginUrlQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary loginWithAppleToken
 */
export const loginWithAppleToken = (
  loginWithAppleTokenRequest: LoginWithAppleTokenRequest,
) => {
  return instance<AccessToken>({
    url: `/api/v1/social-login/apple`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginWithAppleTokenRequest,
  });
};

export const getLoginWithAppleTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithAppleToken>>,
    TError,
    { data: LoginWithAppleTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginWithAppleToken>>,
  TError,
  { data: LoginWithAppleTokenRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginWithAppleToken>>,
    { data: LoginWithAppleTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return loginWithAppleToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginWithAppleTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginWithAppleToken>>
>;
export type LoginWithAppleTokenMutationBody = LoginWithAppleTokenRequest;
export type LoginWithAppleTokenMutationError = ErrorType<unknown>;

/**
 * @summary loginWithAppleToken
 */
export const useLoginWithAppleToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithAppleToken>>,
    TError,
    { data: LoginWithAppleTokenRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginWithAppleToken>>,
  TError,
  { data: LoginWithAppleTokenRequest },
  TContext
> => {
  const mutationOptions = getLoginWithAppleTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Envía por correo electrónico el ticket con la información del cobro hecho a la tarjeta del usuario.
 * @summary sendTicket
 */
export const sendTicket = (id: number) => {
  return instance<Success>({
    url: `/api/v1/reservation/${id}/ticket`,
    method: "POST",
  });
};

export const getSendTicketMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTicket>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTicket>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTicket>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendTicket(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendTicket>>
>;

export type SendTicketMutationError = ErrorType<unknown>;

/**
 * @summary sendTicket
 */
export const useSendTicket = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTicket>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTicket>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getSendTicketMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Califica la actividad de una reserva.
 * @summary rateService
 */
export const rateService = (rateService: RateService) => {
  return instance<Success>({
    url: `/api/v1/reservation/rate-service`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: rateService,
  });
};

export const getRateServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateService>>,
    TError,
    { data: RateService },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rateService>>,
  TError,
  { data: RateService },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rateService>>,
    { data: RateService }
  > = (props) => {
    const { data } = props ?? {};

    return rateService(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RateServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof rateService>>
>;
export type RateServiceMutationBody = RateService;
export type RateServiceMutationError = ErrorType<unknown>;

/**
 * @summary rateService
 */
export const useRateService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateService>>,
    TError,
    { data: RateService },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rateService>>,
  TError,
  { data: RateService },
  TContext
> => {
  const mutationOptions = getRateServiceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Solicita factura del viajero.
 * @summary invoiceRequest
 */
export const invoiceRequest = (invoiceRequest: InvoiceRequest) => {
  return instance<Success>({
    url: `/api/v1/reservation/invoice-request`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: invoiceRequest,
  });
};

export const getInvoiceRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invoiceRequest>>,
    TError,
    { data: InvoiceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invoiceRequest>>,
  TError,
  { data: InvoiceRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invoiceRequest>>,
    { data: InvoiceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return invoiceRequest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvoiceRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof invoiceRequest>>
>;
export type InvoiceRequestMutationBody = InvoiceRequest;
export type InvoiceRequestMutationError = ErrorType<unknown>;

/**
 * @summary invoiceRequest
 */
export const useInvoiceRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invoiceRequest>>,
    TError,
    { data: InvoiceRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof invoiceRequest>>,
  TError,
  { data: InvoiceRequest },
  TContext
> => {
  const mutationOptions = getInvoiceRequestMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Registra una reservación de tarifa individual en la actividad y horario seleccionados por el viajero.
 * @summary individualReservation
 */
export const individualReservation = (
  createIndividualReservationRequest: CreateIndividualReservationRequest,
) => {
  return instance<ReservationCreatedVm>({
    url: `/api/v1/reservation/individual`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createIndividualReservationRequest,
  });
};

export const getIndividualReservationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualReservation>>,
    TError,
    { data: CreateIndividualReservationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof individualReservation>>,
  TError,
  { data: CreateIndividualReservationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof individualReservation>>,
    { data: CreateIndividualReservationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return individualReservation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IndividualReservationMutationResult = NonNullable<
  Awaited<ReturnType<typeof individualReservation>>
>;
export type IndividualReservationMutationBody =
  CreateIndividualReservationRequest;
export type IndividualReservationMutationError = ErrorType<unknown>;

/**
 * @summary individualReservation
 */
export const useIndividualReservation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualReservation>>,
    TError,
    { data: CreateIndividualReservationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof individualReservation>>,
  TError,
  { data: CreateIndividualReservationRequest },
  TContext
> => {
  const mutationOptions = getIndividualReservationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Registra una reservación de tarifa individual detallada en la actividad y horario seleccionados por el viajero.
 * @summary individualDetailedReservation
 */
export const individualDetailedReservation = (
  createIndividualDetailedReservationRequest: CreateIndividualDetailedReservationRequest,
) => {
  return instance<ReservationCreatedVm>({
    url: `/api/v1/reservation/individual-detailed`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createIndividualDetailedReservationRequest,
  });
};

export const getIndividualDetailedReservationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualDetailedReservation>>,
    TError,
    { data: CreateIndividualDetailedReservationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof individualDetailedReservation>>,
  TError,
  { data: CreateIndividualDetailedReservationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof individualDetailedReservation>>,
    { data: CreateIndividualDetailedReservationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return individualDetailedReservation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IndividualDetailedReservationMutationResult = NonNullable<
  Awaited<ReturnType<typeof individualDetailedReservation>>
>;
export type IndividualDetailedReservationMutationBody =
  CreateIndividualDetailedReservationRequest;
export type IndividualDetailedReservationMutationError = ErrorType<unknown>;

/**
 * @summary individualDetailedReservation
 */
export const useIndividualDetailedReservation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualDetailedReservation>>,
    TError,
    { data: CreateIndividualDetailedReservationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof individualDetailedReservation>>,
  TError,
  { data: CreateIndividualDetailedReservationRequest },
  TContext
> => {
  const mutationOptions =
    getIndividualDetailedReservationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Registra una reservación de tarifa por grupo en la actividad y horario seleccionados por el viajero.
 * @summary groupReservation
 */
export const groupReservation = (
  createGroupReservationRequest: CreateGroupReservationRequest,
) => {
  return instance<ReservationCreatedVm>({
    url: `/api/v1/reservation/group`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createGroupReservationRequest,
  });
};

export const getGroupReservationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof groupReservation>>,
    TError,
    { data: CreateGroupReservationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof groupReservation>>,
  TError,
  { data: CreateGroupReservationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof groupReservation>>,
    { data: CreateGroupReservationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return groupReservation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GroupReservationMutationResult = NonNullable<
  Awaited<ReturnType<typeof groupReservation>>
>;
export type GroupReservationMutationBody = CreateGroupReservationRequest;
export type GroupReservationMutationError = ErrorType<unknown>;

/**
 * @summary groupReservation
 */
export const useGroupReservation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof groupReservation>>,
    TError,
    { data: CreateGroupReservationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof groupReservation>>,
  TError,
  { data: CreateGroupReservationRequest },
  TContext
> => {
  const mutationOptions = getGroupReservationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Realiza el draft de tarifa individual de un viajero.
 * @summary individualTariffTypeReservation
 */
export const individualDraft = (
  individualDraftRequest: IndividualDraftRequest,
) => {
  return instance<DraftConfirmationVm>({
    url: `/api/v1/reservation/draft/individual`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: individualDraftRequest,
  });
};

export const getIndividualDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualDraft>>,
    TError,
    { data: IndividualDraftRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof individualDraft>>,
  TError,
  { data: IndividualDraftRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof individualDraft>>,
    { data: IndividualDraftRequest }
  > = (props) => {
    const { data } = props ?? {};

    return individualDraft(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IndividualDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof individualDraft>>
>;
export type IndividualDraftMutationBody = IndividualDraftRequest;
export type IndividualDraftMutationError = ErrorType<unknown>;

/**
 * @summary individualTariffTypeReservation
 */
export const useIndividualDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualDraft>>,
    TError,
    { data: IndividualDraftRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof individualDraft>>,
  TError,
  { data: IndividualDraftRequest },
  TContext
> => {
  const mutationOptions = getIndividualDraftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Realiza el draft de tarifa individual detallada de un viajero.
 * @summary individualDetailedTariffTypeReservation
 */
export const individualDetailedDraft = (
  individualDetailedDraftRequest: IndividualDetailedDraftRequest,
) => {
  return instance<DraftConfirmationVm>({
    url: `/api/v1/reservation/draft/individual-detailed`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: individualDetailedDraftRequest,
  });
};

export const getIndividualDetailedDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualDetailedDraft>>,
    TError,
    { data: IndividualDetailedDraftRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof individualDetailedDraft>>,
  TError,
  { data: IndividualDetailedDraftRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof individualDetailedDraft>>,
    { data: IndividualDetailedDraftRequest }
  > = (props) => {
    const { data } = props ?? {};

    return individualDetailedDraft(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IndividualDetailedDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof individualDetailedDraft>>
>;
export type IndividualDetailedDraftMutationBody =
  IndividualDetailedDraftRequest;
export type IndividualDetailedDraftMutationError = ErrorType<unknown>;

/**
 * @summary individualDetailedTariffTypeReservation
 */
export const useIndividualDetailedDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof individualDetailedDraft>>,
    TError,
    { data: IndividualDetailedDraftRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof individualDetailedDraft>>,
  TError,
  { data: IndividualDetailedDraftRequest },
  TContext
> => {
  const mutationOptions = getIndividualDetailedDraftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Realiza el draft de tarifa grupal de un viajero.
 * @summary groupTariffTypeReservation
 */
export const groupDraft = (groupDraftRequest: GroupDraftRequest) => {
  return instance<DraftConfirmationVm>({
    url: `/api/v1/reservation/draft/group`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: groupDraftRequest,
  });
};

export const getGroupDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof groupDraft>>,
    TError,
    { data: GroupDraftRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof groupDraft>>,
  TError,
  { data: GroupDraftRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof groupDraft>>,
    { data: GroupDraftRequest }
  > = (props) => {
    const { data } = props ?? {};

    return groupDraft(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GroupDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof groupDraft>>
>;
export type GroupDraftMutationBody = GroupDraftRequest;
export type GroupDraftMutationError = ErrorType<unknown>;

/**
 * @summary groupTariffTypeReservation
 */
export const useGroupDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof groupDraft>>,
    TError,
    { data: GroupDraftRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof groupDraft>>,
  TError,
  { data: GroupDraftRequest },
  TContext
> => {
  const mutationOptions = getGroupDraftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Registra una reservación en la actividad y horario seleccionados por el viajero.
 * @summary reservation
 */
export const draftConfirmationPayment = (
  draftConfirmationPaymentRequest: DraftConfirmationPaymentRequest,
) => {
  return instance<DraftConfirmationVm>({
    url: `/api/v1/reservation/draft-confirmation-payment`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: draftConfirmationPaymentRequest,
  });
};

export const getDraftConfirmationPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof draftConfirmationPayment>>,
    TError,
    { data: DraftConfirmationPaymentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof draftConfirmationPayment>>,
  TError,
  { data: DraftConfirmationPaymentRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof draftConfirmationPayment>>,
    { data: DraftConfirmationPaymentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return draftConfirmationPayment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DraftConfirmationPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof draftConfirmationPayment>>
>;
export type DraftConfirmationPaymentMutationBody =
  DraftConfirmationPaymentRequest;
export type DraftConfirmationPaymentMutationError = ErrorType<unknown>;

/**
 * @summary reservation
 */
export const useDraftConfirmationPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof draftConfirmationPayment>>,
    TError,
    { data: DraftConfirmationPaymentRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof draftConfirmationPayment>>,
  TError,
  { data: DraftConfirmationPaymentRequest },
  TContext
> => {
  const mutationOptions = getDraftConfirmationPaymentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Cambia la fecha de reserva sugerida por el proveedor.
 * @summary changeReservationDateFromSupplier
 */
export const changeReservationDateFromSupplier = (
  changeReservationDateRequest: ChangeReservationDateRequest,
) => {
  return instance<ReservationCreatedVm>({
    url: `/api/v1/reservation/change-reservation-date-from-supplier`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: changeReservationDateRequest,
  });
};

export const getChangeReservationDateFromSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeReservationDateFromSupplier>>,
    TError,
    { data: ChangeReservationDateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeReservationDateFromSupplier>>,
  TError,
  { data: ChangeReservationDateRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeReservationDateFromSupplier>>,
    { data: ChangeReservationDateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return changeReservationDateFromSupplier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeReservationDateFromSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeReservationDateFromSupplier>>
>;
export type ChangeReservationDateFromSupplierMutationBody =
  ChangeReservationDateRequest;
export type ChangeReservationDateFromSupplierMutationError = ErrorType<unknown>;

/**
 * @summary changeReservationDateFromSupplier
 */
export const useChangeReservationDateFromSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeReservationDateFromSupplier>>,
    TError,
    { data: ChangeReservationDateRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeReservationDateFromSupplier>>,
  TError,
  { data: ChangeReservationDateRequest },
  TContext
> => {
  const mutationOptions =
    getChangeReservationDateFromSupplierMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Agrega un método de pago al perfil del usuario.
 * @summary registerPaymentMethod
 */
export const registerPaymentMethod = (cardDetail: CardDetail) => {
  return instance<Success>({
    url: `/api/v1/profile/payment-method`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cardDetail,
  });
};

export const getRegisterPaymentMethodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPaymentMethod>>,
    TError,
    { data: CardDetail },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerPaymentMethod>>,
  TError,
  { data: CardDetail },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerPaymentMethod>>,
    { data: CardDetail }
  > = (props) => {
    const { data } = props ?? {};

    return registerPaymentMethod(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterPaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerPaymentMethod>>
>;
export type RegisterPaymentMethodMutationBody = CardDetail;
export type RegisterPaymentMethodMutationError = ErrorType<unknown>;

/**
 * @summary registerPaymentMethod
 */
export const useRegisterPaymentMethod = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPaymentMethod>>,
    TError,
    { data: CardDetail },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerPaymentMethod>>,
  TError,
  { data: CardDetail },
  TContext
> => {
  const mutationOptions = getRegisterPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza la información de un método de pago del usuario.
 * @summary updatePaymentMethod
 */
export const updatePaymentMethod = (
  updatePaymentMethod: UpdatePaymentMethod,
) => {
  return instance<Success>({
    url: `/api/v1/profile/payment-method`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updatePaymentMethod,
  });
};

export const getUpdatePaymentMethodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePaymentMethod>>,
    TError,
    { data: UpdatePaymentMethod },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePaymentMethod>>,
  TError,
  { data: UpdatePaymentMethod },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePaymentMethod>>,
    { data: UpdatePaymentMethod }
  > = (props) => {
    const { data } = props ?? {};

    return updatePaymentMethod(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePaymentMethod>>
>;
export type UpdatePaymentMethodMutationBody = UpdatePaymentMethod;
export type UpdatePaymentMethodMutationError = ErrorType<unknown>;

/**
 * @summary updatePaymentMethod
 */
export const useUpdatePaymentMethod = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePaymentMethod>>,
    TError,
    { data: UpdatePaymentMethod },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePaymentMethod>>,
  TError,
  { data: UpdatePaymentMethod },
  TContext
> => {
  const mutationOptions = getUpdatePaymentMethodMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Agrega una actividad favorita del viajero.
 * @summary addFavoriteTravelerActivity
 */
export const addFavoriteTravelerActivity = (
  favoriteTravelerActivity: FavoriteTravelerActivity,
) => {
  return instance<Success>({
    url: `/api/v1/profile/favorite-activity`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: favoriteTravelerActivity,
  });
};

export const getAddFavoriteTravelerActivityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFavoriteTravelerActivity>>,
    TError,
    { data: FavoriteTravelerActivity },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addFavoriteTravelerActivity>>,
  TError,
  { data: FavoriteTravelerActivity },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addFavoriteTravelerActivity>>,
    { data: FavoriteTravelerActivity }
  > = (props) => {
    const { data } = props ?? {};

    return addFavoriteTravelerActivity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddFavoriteTravelerActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof addFavoriteTravelerActivity>>
>;
export type AddFavoriteTravelerActivityMutationBody = FavoriteTravelerActivity;
export type AddFavoriteTravelerActivityMutationError = ErrorType<unknown>;

/**
 * @summary addFavoriteTravelerActivity
 */
export const useAddFavoriteTravelerActivity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFavoriteTravelerActivity>>,
    TError,
    { data: FavoriteTravelerActivity },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addFavoriteTravelerActivity>>,
  TError,
  { data: FavoriteTravelerActivity },
  TContext
> => {
  const mutationOptions =
    getAddFavoriteTravelerActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Elimina una actividad favorita del viajero.
 * @summary removeFavoriteTravelerActivity
 */
export const removeFavoriteTravelerActivity = (
  favoriteTravelerActivity: FavoriteTravelerActivity,
) => {
  return instance<Success>({
    url: `/api/v1/profile/favorite-activity`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: favoriteTravelerActivity,
  });
};

export const getRemoveFavoriteTravelerActivityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteTravelerActivity>>,
    TError,
    { data: FavoriteTravelerActivity },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFavoriteTravelerActivity>>,
  TError,
  { data: FavoriteTravelerActivity },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFavoriteTravelerActivity>>,
    { data: FavoriteTravelerActivity }
  > = (props) => {
    const { data } = props ?? {};

    return removeFavoriteTravelerActivity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFavoriteTravelerActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFavoriteTravelerActivity>>
>;
export type RemoveFavoriteTravelerActivityMutationBody =
  FavoriteTravelerActivity;
export type RemoveFavoriteTravelerActivityMutationError = ErrorType<unknown>;

/**
 * @summary removeFavoriteTravelerActivity
 */
export const useRemoveFavoriteTravelerActivity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteTravelerActivity>>,
    TError,
    { data: FavoriteTravelerActivity },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeFavoriteTravelerActivity>>,
  TError,
  { data: FavoriteTravelerActivity },
  TContext
> => {
  const mutationOptions =
    getRemoveFavoriteTravelerActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Obtiene los mensajes de airship del traveler.
 * @summary getTravelerAirshipMessages
 */
export const getTravelerAirshipMessages = (
  params?: GetTravelerAirshipMessagesParams,
  signal?: AbortSignal,
) => {
  return instance<PageVmAirshipMessage>({
    url: `/api/v1/profile/airship`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTravelerAirshipMessagesQueryKey = (
  params?: GetTravelerAirshipMessagesParams,
) => {
  return [`/api/v1/profile/airship`, ...(params ? [params] : [])] as const;
};

export const getGetTravelerAirshipMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTravelerAirshipMessages>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTravelerAirshipMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTravelerAirshipMessages>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTravelerAirshipMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTravelerAirshipMessages>>
  > = ({ signal }) => getTravelerAirshipMessages(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTravelerAirshipMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTravelerAirshipMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTravelerAirshipMessages>>
>;
export type GetTravelerAirshipMessagesQueryError = ErrorType<unknown>;

/**
 * @summary getTravelerAirshipMessages
 */
export const useGetTravelerAirshipMessages = <
  TData = Awaited<ReturnType<typeof getTravelerAirshipMessages>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTravelerAirshipMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTravelerAirshipMessages>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTravelerAirshipMessagesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Guarda un mensaje de Airship.
 * @summary saveTravelerAirshipMessage
 */
export const saveTravelerAirshipMessage = (
  saveTravelerAirshipMessageRequest: SaveTravelerAirshipMessageRequest,
) => {
  return instance<Success>({
    url: `/api/v1/profile/airship`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: saveTravelerAirshipMessageRequest,
  });
};

export const getSaveTravelerAirshipMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveTravelerAirshipMessage>>,
    TError,
    { data: SaveTravelerAirshipMessageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveTravelerAirshipMessage>>,
  TError,
  { data: SaveTravelerAirshipMessageRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveTravelerAirshipMessage>>,
    { data: SaveTravelerAirshipMessageRequest }
  > = (props) => {
    const { data } = props ?? {};

    return saveTravelerAirshipMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveTravelerAirshipMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveTravelerAirshipMessage>>
>;
export type SaveTravelerAirshipMessageMutationBody =
  SaveTravelerAirshipMessageRequest;
export type SaveTravelerAirshipMessageMutationError = ErrorType<unknown>;

/**
 * @summary saveTravelerAirshipMessage
 */
export const useSaveTravelerAirshipMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveTravelerAirshipMessage>>,
    TError,
    { data: SaveTravelerAirshipMessageRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveTravelerAirshipMessage>>,
  TError,
  { data: SaveTravelerAirshipMessageRequest },
  TContext
> => {
  const mutationOptions = getSaveTravelerAirshipMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Guarda la solicitud de aceptar los términos y condiciones del usuario.
 * @summary acceptTermsAndConditions
 */
export const acceptTermsAndConditions = () => {
  return instance<Success>({
    url: `/api/v1/profile/accept-tyc`,
    method: "POST",
  });
};

export const getAcceptTermsAndConditionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTermsAndConditions>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptTermsAndConditions>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptTermsAndConditions>>,
    void
  > = () => {
    return acceptTermsAndConditions();
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptTermsAndConditionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptTermsAndConditions>>
>;

export type AcceptTermsAndConditionsMutationError = ErrorType<unknown>;

/**
 * @summary acceptTermsAndConditions
 */
export const useAcceptTermsAndConditions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTermsAndConditions>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptTermsAndConditions>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAcceptTermsAndConditionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de escribir una reseña de una actividad
 * @summary write5Reviews
 */
export const write5Reviews = () => {
  return instance<Success>({
    url: `/api/v1/challenge/write5Reviews`,
    method: "POST",
  });
};

export const getWrite5ReviewsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof write5Reviews>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof write5Reviews>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof write5Reviews>>,
    void
  > = () => {
    return write5Reviews();
  };

  return { mutationFn, ...mutationOptions };
};

export type Write5ReviewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof write5Reviews>>
>;

export type Write5ReviewsMutationError = ErrorType<unknown>;

/**
 * @summary write5Reviews
 */
export const useWrite5Reviews = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof write5Reviews>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof write5Reviews>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getWrite5ReviewsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de compartir una actividad para el conteo de retos
 * @summary updateShareEvent
 */
export const updateShareEvent = () => {
  return instance<Success>({
    url: `/api/v1/challenge/update/share-event`,
    method: "POST",
  });
};

export const getUpdateShareEventMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShareEvent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateShareEvent>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateShareEvent>>,
    void
  > = () => {
    return updateShareEvent();
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateShareEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateShareEvent>>
>;

export type UpdateShareEventMutationError = ErrorType<unknown>;

/**
 * @summary updateShareEvent
 */
export const useUpdateShareEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShareEvent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateShareEvent>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getUpdateShareEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de calificar la app
 * @summary rateApp
 */
export const rateApp = () => {
  return instance<Success>({
    url: `/api/v1/challenge/rateApp`,
    method: "POST",
  });
};

export const getRateAppMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateApp>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rateApp>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rateApp>>,
    void
  > = () => {
    return rateApp();
  };

  return { mutationFn, ...mutationOptions };
};

export type RateAppMutationResult = NonNullable<
  Awaited<ReturnType<typeof rateApp>>
>;

export type RateAppMutationError = ErrorType<unknown>;

/**
 * @summary rateApp
 */
export const useRateApp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateApp>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rateApp>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRateAppMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de calificar una actividad
 * @summary rateActivity
 */
export const rateActivity = () => {
  return instance<Success>({
    url: `/api/v1/challenge/rateActivity`,
    method: "POST",
  });
};

export const getRateActivityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateActivity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rateActivity>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rateActivity>>,
    void
  > = () => {
    return rateActivity();
  };

  return { mutationFn, ...mutationOptions };
};

export type RateActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof rateActivity>>
>;

export type RateActivityMutationError = ErrorType<unknown>;

/**
 * @summary rateActivity
 */
export const useRateActivity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateActivity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rateActivity>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRateActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de subscribirse a la newsletter
 * @summary newsletter
 */
export const subscribeNewsLetter = () => {
  return instance<Success>({
    url: `/api/v1/challenge/newsletter`,
    method: "POST",
  });
};

export const getSubscribeNewsLetterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribeNewsLetter>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscribeNewsLetter>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscribeNewsLetter>>,
    void
  > = () => {
    return subscribeNewsLetter();
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscribeNewsLetterMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscribeNewsLetter>>
>;

export type SubscribeNewsLetterMutationError = ErrorType<unknown>;

/**
 * @summary newsletter
 */
export const useSubscribeNewsLetter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribeNewsLetter>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscribeNewsLetter>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSubscribeNewsLetterMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Obtiene el cupón del cashback
 * @summary getCashbackCoupon
 */
export const getCashbackCoupon = (
  cashbackCouponRequest: CashbackCouponRequest,
) => {
  return instance<CashbackCouponVm>({
    url: `/api/v1/cashback/coupon`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cashbackCouponRequest,
  });
};

export const getGetCashbackCouponMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCashbackCoupon>>,
    TError,
    { data: CashbackCouponRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getCashbackCoupon>>,
  TError,
  { data: CashbackCouponRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getCashbackCoupon>>,
    { data: CashbackCouponRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getCashbackCoupon(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetCashbackCouponMutationResult = NonNullable<
  Awaited<ReturnType<typeof getCashbackCoupon>>
>;
export type GetCashbackCouponMutationBody = CashbackCouponRequest;
export type GetCashbackCouponMutationError = ErrorType<unknown>;

/**
 * @summary getCashbackCoupon
 */
export const useGetCashbackCoupon = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCashbackCoupon>>,
    TError,
    { data: CashbackCouponRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof getCashbackCoupon>>,
  TError,
  { data: CashbackCouponRequest },
  TContext
> => {
  const mutationOptions = getGetCashbackCouponMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de insignia al escribir una reseña
 * @summary write-review
 */
export const writeReview = () => {
  return instance<Success>({
    url: `/api/v1/badge/write-review`,
    method: "POST",
  });
};

export const getWriteReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof writeReview>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof writeReview>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof writeReview>>,
    void
  > = () => {
    return writeReview();
  };

  return { mutationFn, ...mutationOptions };
};

export type WriteReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof writeReview>>
>;

export type WriteReviewMutationError = ErrorType<unknown>;

/**
 * @summary write-review
 */
export const useWriteReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof writeReview>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof writeReview>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getWriteReviewMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de insignia al suscribirse al newsletter
 * @summary subscribe-newsletter
 */
export const subscribeNewsletter = () => {
  return instance<Success>({
    url: `/api/v1/badge/subscribe-newsletter`,
    method: "POST",
  });
};

export const getSubscribeNewsletterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribeNewsletter>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscribeNewsletter>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscribeNewsletter>>,
    void
  > = () => {
    return subscribeNewsletter();
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscribeNewsletterMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscribeNewsletter>>
>;

export type SubscribeNewsletterMutationError = ErrorType<unknown>;

/**
 * @summary subscribe-newsletter
 */
export const useSubscribeNewsletter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribeNewsletter>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscribeNewsletter>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSubscribeNewsletterMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de insignia al compartir una actividad
 * @summary share-activity
 */
export const shareActivity = () => {
  return instance<Success>({
    url: `/api/v1/badge/share-activity`,
    method: "POST",
  });
};

export const getShareActivityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareActivity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shareActivity>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareActivity>>,
    void
  > = () => {
    return shareActivity();
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof shareActivity>>
>;

export type ShareActivityMutationError = ErrorType<unknown>;

/**
 * @summary share-activity
 */
export const useShareActivity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareActivity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof shareActivity>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getShareActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de insignia al calificar 5 actividades
 * @summary rate-activity
 */
export const rateActivity1 = () => {
  return instance<Success>({
    url: `/api/v1/badge/rate-activity`,
    method: "POST",
  });
};

export const getRateActivity1MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateActivity1>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rateActivity1>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rateActivity1>>,
    void
  > = () => {
    return rateActivity1();
  };

  return { mutationFn, ...mutationOptions };
};

export type RateActivity1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rateActivity1>>
>;

export type RateActivity1MutationError = ErrorType<unknown>;

/**
 * @summary rate-activity
 */
export const useRateActivity1 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateActivity1>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rateActivity1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRateActivity1MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de insignia al dejar una actividad en el checkout
 * @summary left-activity-checkout
 */
export const leftActivityCheckout = () => {
  return instance<Success>({
    url: `/api/v1/badge/left-activity-checkout`,
    method: "POST",
  });
};

export const getLeftActivityCheckoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leftActivityCheckout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof leftActivityCheckout>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof leftActivityCheckout>>,
    void
  > = () => {
    return leftActivityCheckout();
  };

  return { mutationFn, ...mutationOptions };
};

export type LeftActivityCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof leftActivityCheckout>>
>;

export type LeftActivityCheckoutMutationError = ErrorType<unknown>;

/**
 * @summary left-activity-checkout
 */
export const useLeftActivityCheckout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leftActivityCheckout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof leftActivityCheckout>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getLeftActivityCheckoutMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de insignia al realizar una búsqueda
 * @summary first-search
 */
export const firstSearch = () => {
  return instance<Success>({
    url: `/api/v1/badge/first-search`,
    method: "POST",
  });
};

export const getFirstSearchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof firstSearch>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof firstSearch>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof firstSearch>>,
    void
  > = () => {
    return firstSearch();
  };

  return { mutationFn, ...mutationOptions };
};

export type FirstSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof firstSearch>>
>;

export type FirstSearchMutationError = ErrorType<unknown>;

/**
 * @summary first-search
 */
export const useFirstSearch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof firstSearch>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof firstSearch>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getFirstSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de explora el mapa por primera vez
 * @summary explore-map
 */
export const exploreMap = () => {
  return instance<Success>({
    url: `/api/v1/badge/explore-map`,
    method: "POST",
  });
};

export const getExploreMapMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exploreMap>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exploreMap>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exploreMap>>,
    void
  > = () => {
    return exploreMap();
  };

  return { mutationFn, ...mutationOptions };
};

export type ExploreMapMutationResult = NonNullable<
  Awaited<ReturnType<typeof exploreMap>>
>;

export type ExploreMapMutationError = ErrorType<unknown>;

/**
 * @summary explore-map
 */
export const useExploreMap = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exploreMap>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exploreMap>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getExploreMapMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el evento de insignia al usar filtros avanzados
 * @summary advanced-filters
 */
export const advancedFilters = () => {
  return instance<Success>({
    url: `/api/v1/badge/advanced-filters`,
    method: "POST",
  });
};

export const getAdvancedFiltersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof advancedFilters>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof advancedFilters>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof advancedFilters>>,
    void
  > = () => {
    return advancedFilters();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdvancedFiltersMutationResult = NonNullable<
  Awaited<ReturnType<typeof advancedFilters>>
>;

export type AdvancedFiltersMutationError = ErrorType<unknown>;

/**
 * @summary advanced-filters
 */
export const useAdvancedFilters = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof advancedFilters>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof advancedFilters>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAdvancedFiltersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Registro de usuarios. Los usuarios solo son registrados en el base de datos de VEE. 
El registro de los usuarios se realiza por medio del SDK de AWS desde el FrontEnd.
 * @summary sign-up
 */
export const signUp = (signupRequest: SignupRequest) => {
  return instance<Success>({
    url: `/api/v1/auth/sign-up`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: signupRequest,
  });
};

export const getSignUpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUp>>,
    TError,
    { data: SignupRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signUp>>,
  TError,
  { data: SignupRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signUp>>,
    { data: SignupRequest }
  > = (props) => {
    const { data } = props ?? {};

    return signUp(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof signUp>>
>;
export type SignUpMutationBody = SignupRequest;
export type SignUpMutationError = ErrorType<unknown>;

/**
 * @summary sign-up
 */
export const useSignUp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUp>>,
    TError,
    { data: SignupRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof signUp>>,
  TError,
  { data: SignupRequest },
  TContext
> => {
  const mutationOptions = getSignUpMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Registro de usuarios. Los usuarios solo son registrados en el base de datos de VEE. 
El registro de los usuarios se realiza por medio del SDK de AWS desde el FrontEnd.
 * @summary sign-up-anon
 */
export const signUpAnon = (signupAnonRequest: SignupAnonRequest) => {
  return instance<AnonymousTokenDto>({
    url: `/api/v1/auth/sign-up-anon`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: signupAnonRequest,
  });
};

export const getSignUpAnonMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUpAnon>>,
    TError,
    { data: SignupAnonRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signUpAnon>>,
  TError,
  { data: SignupAnonRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signUpAnon>>,
    { data: SignupAnonRequest }
  > = (props) => {
    const { data } = props ?? {};

    return signUpAnon(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignUpAnonMutationResult = NonNullable<
  Awaited<ReturnType<typeof signUpAnon>>
>;
export type SignUpAnonMutationBody = SignupAnonRequest;
export type SignUpAnonMutationError = ErrorType<unknown>;

/**
 * @summary sign-up-anon
 */
export const useSignUpAnon = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUpAnon>>,
    TError,
    { data: SignupAnonRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof signUpAnon>>,
  TError,
  { data: SignupAnonRequest },
  TContext
> => {
  const mutationOptions = getSignUpAnonMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Valida de las credenciales del usuario. <br/><br/>Obtiene token de acceso únicamente de usuarios propios de VEE, y no usuarios provenientes de alguna red social.
 * @summary sign-in
 */
export const signIn = (signIn: SignIn) => {
  return instance<AccessToken>({
    url: `/api/v1/auth/sign-in`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: signIn,
  });
};

export const getSignInMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signIn>>,
    TError,
    { data: SignIn },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signIn>>,
  TError,
  { data: SignIn },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signIn>>,
    { data: SignIn }
  > = (props) => {
    const { data } = props ?? {};

    return signIn(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInMutationResult = NonNullable<
  Awaited<ReturnType<typeof signIn>>
>;
export type SignInMutationBody = SignIn;
export type SignInMutationError = ErrorType<unknown>;

/**
 * @summary sign-in
 */
export const useSignIn = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signIn>>,
    TError,
    { data: SignIn },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof signIn>>,
  TError,
  { data: SignIn },
  TContext
> => {
  const mutationOptions = getSignInMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Refresh token
 * @summary refresh-access-token
 */
export const refreshAccessToken = (refreshTokenDto: RefreshTokenDto) => {
  return instance<AccessToken>({
    url: `/api/v1/auth/refresh-access-token`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: refreshTokenDto,
  });
};

export const getRefreshAccessTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshAccessToken>>,
    TError,
    { data: RefreshTokenDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshAccessToken>>,
  TError,
  { data: RefreshTokenDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshAccessToken>>,
    { data: RefreshTokenDto }
  > = (props) => {
    const { data } = props ?? {};

    return refreshAccessToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshAccessTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshAccessToken>>
>;
export type RefreshAccessTokenMutationBody = RefreshTokenDto;
export type RefreshAccessTokenMutationError = ErrorType<unknown>;

/**
 * @summary refresh-access-token
 */
export const useRefreshAccessToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshAccessToken>>,
    TError,
    { data: RefreshTokenDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshAccessToken>>,
  TError,
  { data: RefreshTokenDto },
  TContext
> => {
  const mutationOptions = getRefreshAccessTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary logout
 */
export const logout = (logoutDto: LogoutDto) => {
  return instance<Success>({
    url: `/api/v1/auth/logout`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: logoutDto,
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    { data: LogoutDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  { data: LogoutDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    { data: LogoutDto }
  > = (props) => {
    const { data } = props ?? {};

    return logout(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;
export type LogoutMutationBody = LogoutDto;
export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary logout
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    { data: LogoutDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  { data: LogoutDto },
  TContext
> => {
  const mutationOptions = getLogoutMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Inicia el proceso de cambio de contraseña del usuario enviando un código de verificación.
 * @summary forgot-password
 */
export const forgotPassword = (forgotPassword: ForgotPassword) => {
  return instance<Success>({
    url: `/api/v1/auth/forgot-password`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: forgotPassword,
  });
};

export const getForgotPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: ForgotPassword },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: ForgotPassword },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPassword>>,
    { data: ForgotPassword }
  > = (props) => {
    const { data } = props ?? {};

    return forgotPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof forgotPassword>>
>;
export type ForgotPasswordMutationBody = ForgotPassword;
export type ForgotPasswordMutationError = ErrorType<unknown>;

/**
 * @summary forgot-password
 */
export const useForgotPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: ForgotPassword },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: ForgotPassword },
  TContext
> => {
  const mutationOptions = getForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary delete-account
 */
export const deleteAccount = (deleteAccountDto: DeleteAccountDto) => {
  return instance<Success>({
    url: `/api/v1/auth/delete-account`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: deleteAccountDto,
  });
};

export const getDeleteAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    { data: DeleteAccountDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  { data: DeleteAccountDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccount>>,
    { data: DeleteAccountDto }
  > = (props) => {
    const { data } = props ?? {};

    return deleteAccount(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccount>>
>;
export type DeleteAccountMutationBody = DeleteAccountDto;
export type DeleteAccountMutationError = ErrorType<unknown>;

/**
 * @summary delete-account
 */
export const useDeleteAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    { data: DeleteAccountDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  { data: DeleteAccountDto },
  TContext
> => {
  const mutationOptions = getDeleteAccountMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary add-airship-channel
 */
export const addAirshipChannel = (
  addAirshipChannelDto: AddAirshipChannelDto,
) => {
  return instance<Success>({
    url: `/api/v1/auth/add-airship-channel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addAirshipChannelDto,
  });
};

export const getAddAirshipChannelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAirshipChannel>>,
    TError,
    { data: AddAirshipChannelDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addAirshipChannel>>,
  TError,
  { data: AddAirshipChannelDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addAirshipChannel>>,
    { data: AddAirshipChannelDto }
  > = (props) => {
    const { data } = props ?? {};

    return addAirshipChannel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddAirshipChannelMutationResult = NonNullable<
  Awaited<ReturnType<typeof addAirshipChannel>>
>;
export type AddAirshipChannelMutationBody = AddAirshipChannelDto;
export type AddAirshipChannelMutationError = ErrorType<unknown>;

/**
 * @summary add-airship-channel
 */
export const useAddAirshipChannel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAirshipChannel>>,
    TError,
    { data: AddAirshipChannelDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addAirshipChannel>>,
  TError,
  { data: AddAirshipChannelDto },
  TContext
> => {
  const mutationOptions = getAddAirshipChannelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Obtiene las tarifas disponibles para un schedule
 * @summary getAvailableTariffBySchedule
 */
export const getAvailableTariffBySchedule = (
  activityAvailableTariffRequest: ActivityAvailableTariffRequest,
) => {
  return instance<ActivityTariffAvailability[]>({
    url: `/api/v1/activity/schedule/tariffs`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: activityAvailableTariffRequest,
  });
};

export const getGetAvailableTariffByScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableTariffBySchedule>>,
    TError,
    { data: ActivityAvailableTariffRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvailableTariffBySchedule>>,
  TError,
  { data: ActivityAvailableTariffRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvailableTariffBySchedule>>,
    { data: ActivityAvailableTariffRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getAvailableTariffBySchedule(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvailableTariffByScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableTariffBySchedule>>
>;
export type GetAvailableTariffByScheduleMutationBody =
  ActivityAvailableTariffRequest;
export type GetAvailableTariffByScheduleMutationError = ErrorType<unknown>;

/**
 * @summary getAvailableTariffBySchedule
 */
export const useGetAvailableTariffBySchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableTariffBySchedule>>,
    TError,
    { data: ActivityAvailableTariffRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAvailableTariffBySchedule>>,
  TError,
  { data: ActivityAvailableTariffRequest },
  TContext
> => {
  const mutationOptions =
    getGetAvailableTariffByScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Obtiene las listas de favoritas del viajero.
 * @summary getFavoriteLists
 */
export const getFavoriteTravelerActivityList = (
  params?: GetFavoriteTravelerActivityListParams,
  signal?: AbortSignal,
) => {
  return instance<PageVmFavoriteTravelerActivityListVm>({
    url: `/api/v1/activity/favorite/list`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFavoriteTravelerActivityListQueryKey = (
  params?: GetFavoriteTravelerActivityListParams,
) => {
  return [
    `/api/v1/activity/favorite/list`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFavoriteTravelerActivityListQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavoriteTravelerActivityList>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFavoriteTravelerActivityListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFavoriteTravelerActivityList>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFavoriteTravelerActivityListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFavoriteTravelerActivityList>>
  > = ({ signal }) => getFavoriteTravelerActivityList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavoriteTravelerActivityList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFavoriteTravelerActivityListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavoriteTravelerActivityList>>
>;
export type GetFavoriteTravelerActivityListQueryError = ErrorType<unknown>;

/**
 * @summary getFavoriteLists
 */
export const useGetFavoriteTravelerActivityList = <
  TData = Awaited<ReturnType<typeof getFavoriteTravelerActivityList>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFavoriteTravelerActivityListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFavoriteTravelerActivityList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFavoriteTravelerActivityListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Registra una lista de actividades favoritas para el viajero.
 * @summary createFavoriteList
 */
export const createFavoriteLists = (
  createFavoriteTravelerActivityListRequest: CreateFavoriteTravelerActivityListRequest,
) => {
  return instance<Success>({
    url: `/api/v1/activity/favorite/list`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFavoriteTravelerActivityListRequest,
  });
};

export const getCreateFavoriteListsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFavoriteLists>>,
    TError,
    { data: CreateFavoriteTravelerActivityListRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFavoriteLists>>,
  TError,
  { data: CreateFavoriteTravelerActivityListRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFavoriteLists>>,
    { data: CreateFavoriteTravelerActivityListRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createFavoriteLists(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFavoriteListsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFavoriteLists>>
>;
export type CreateFavoriteListsMutationBody =
  CreateFavoriteTravelerActivityListRequest;
export type CreateFavoriteListsMutationError = ErrorType<unknown>;

/**
 * @summary createFavoriteList
 */
export const useCreateFavoriteLists = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFavoriteLists>>,
    TError,
    { data: CreateFavoriteTravelerActivityListRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFavoriteLists>>,
  TError,
  { data: CreateFavoriteTravelerActivityListRequest },
  TContext
> => {
  const mutationOptions = getCreateFavoriteListsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza una lista de actividades favoritas para el viajero.
 * @summary updateFavoriteList
 */
export const updateFavoriteLists = (
  id: number,
  updateFavoriteTravelerActivityListRequest: UpdateFavoriteTravelerActivityListRequest,
) => {
  return instance<Success>({
    url: `/api/v1/activity/favorite/list/${id}/update`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateFavoriteTravelerActivityListRequest,
  });
};

export const getUpdateFavoriteListsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFavoriteLists>>,
    TError,
    { id: number; data: UpdateFavoriteTravelerActivityListRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFavoriteLists>>,
  TError,
  { id: number; data: UpdateFavoriteTravelerActivityListRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFavoriteLists>>,
    { id: number; data: UpdateFavoriteTravelerActivityListRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFavoriteLists(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFavoriteListsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFavoriteLists>>
>;
export type UpdateFavoriteListsMutationBody =
  UpdateFavoriteTravelerActivityListRequest;
export type UpdateFavoriteListsMutationError = ErrorType<unknown>;

/**
 * @summary updateFavoriteList
 */
export const useUpdateFavoriteLists = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFavoriteLists>>,
    TError,
    { id: number; data: UpdateFavoriteTravelerActivityListRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFavoriteLists>>,
  TError,
  { id: number; data: UpdateFavoriteTravelerActivityListRequest },
  TContext
> => {
  const mutationOptions = getUpdateFavoriteListsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Califica la reservación del viajero autorizado.
 * @summary gradeReservation
 */
export const gradeReservation = (
  reservationId: number,
  reservationFeedback: ReservationFeedback,
) => {
  return instance<Success>({
    url: `/api/v1/reservation/${reservationId}/grade`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: reservationFeedback,
  });
};

export const getGradeReservationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gradeReservation>>,
    TError,
    { reservationId: number; data: ReservationFeedback },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof gradeReservation>>,
  TError,
  { reservationId: number; data: ReservationFeedback },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gradeReservation>>,
    { reservationId: number; data: ReservationFeedback }
  > = (props) => {
    const { reservationId, data } = props ?? {};

    return gradeReservation(reservationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GradeReservationMutationResult = NonNullable<
  Awaited<ReturnType<typeof gradeReservation>>
>;
export type GradeReservationMutationBody = ReservationFeedback;
export type GradeReservationMutationError = ErrorType<unknown>;

/**
 * @summary gradeReservation
 */
export const useGradeReservation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gradeReservation>>,
    TError,
    { reservationId: number; data: ReservationFeedback },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof gradeReservation>>,
  TError,
  { reservationId: number; data: ReservationFeedback },
  TContext
> => {
  const mutationOptions = getGradeReservationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cancel = (id: number) => {
  return instance<Success>({
    url: `/api/v1/reservation/${id}/cancel`,
    method: "PATCH",
  });
};

export const getCancelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancel>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancel>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancel>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return cancel(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancel>>
>;

export type CancelMutationError = ErrorType<unknown>;

export const useCancel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancel>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancel>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getCancelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Regresa la información general del viajero.
 * @summary fetchGeneralInfo
 */
export const fetchGeneralInfo = (signal?: AbortSignal) => {
  return instance<TravelerVm>({
    url: `/api/v1/profile`,
    method: "GET",
    signal,
  });
};

export const getFetchGeneralInfoQueryKey = () => {
  return [`/api/v1/profile`] as const;
};

export const getFetchGeneralInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchGeneralInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof fetchGeneralInfo>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchGeneralInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchGeneralInfo>>
  > = ({ signal }) => fetchGeneralInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchGeneralInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FetchGeneralInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchGeneralInfo>>
>;
export type FetchGeneralInfoQueryError = ErrorType<unknown>;

/**
 * @summary fetchGeneralInfo
 */
export const useFetchGeneralInfo = <
  TData = Awaited<ReturnType<typeof fetchGeneralInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof fetchGeneralInfo>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFetchGeneralInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Actualiza la información general del viajero.
 * @summary updateProfileInfo
 */
export const updateProfileInfo = (
  updateProfileInfoRequest: UpdateProfileInfoRequest,
) => {
  return instance<TravelerVm>({
    url: `/api/v1/profile`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateProfileInfoRequest,
  });
};

export const getUpdateProfileInfoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfileInfo>>,
    TError,
    { data: UpdateProfileInfoRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfileInfo>>,
  TError,
  { data: UpdateProfileInfoRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfileInfo>>,
    { data: UpdateProfileInfoRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfileInfo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfileInfo>>
>;
export type UpdateProfileInfoMutationBody = UpdateProfileInfoRequest;
export type UpdateProfileInfoMutationError = ErrorType<unknown>;

/**
 * @summary updateProfileInfo
 */
export const useUpdateProfileInfo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfileInfo>>,
    TError,
    { data: UpdateProfileInfoRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfileInfo>>,
  TError,
  { data: UpdateProfileInfoRequest },
  TContext
> => {
  const mutationOptions = getUpdateProfileInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Agrega un idioma preferido para el usuario.
 * @summary addPreferredLanguage
 */
export const addPreferredLanguage = (iso: string) => {
  return instance<TravelerVm>({
    url: `/api/v1/profile/language/${iso}`,
    method: "PATCH",
  });
};

export const getAddPreferredLanguageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPreferredLanguage>>,
    TError,
    { iso: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addPreferredLanguage>>,
  TError,
  { iso: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addPreferredLanguage>>,
    { iso: string }
  > = (props) => {
    const { iso } = props ?? {};

    return addPreferredLanguage(iso);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddPreferredLanguageMutationResult = NonNullable<
  Awaited<ReturnType<typeof addPreferredLanguage>>
>;

export type AddPreferredLanguageMutationError = ErrorType<unknown>;

/**
 * @summary addPreferredLanguage
 */
export const useAddPreferredLanguage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPreferredLanguage>>,
    TError,
    { iso: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addPreferredLanguage>>,
  TError,
  { iso: string },
  TContext
> => {
  const mutationOptions = getAddPreferredLanguageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Actualiza el estado de Airship.
 * @summary changeStatusTravelerAirshipMessage
 */
export const changeStatusTravelerAirshipMessage = (
  id: number,
  updateStatusTravelerAirshipMessageRequest: UpdateStatusTravelerAirshipMessageRequest,
) => {
  return instance<Success>({
    url: `/api/v1/profile/airship/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateStatusTravelerAirshipMessageRequest,
  });
};

export const getChangeStatusTravelerAirshipMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeStatusTravelerAirshipMessage>>,
    TError,
    { id: number; data: UpdateStatusTravelerAirshipMessageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeStatusTravelerAirshipMessage>>,
  TError,
  { id: number; data: UpdateStatusTravelerAirshipMessageRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeStatusTravelerAirshipMessage>>,
    { id: number; data: UpdateStatusTravelerAirshipMessageRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return changeStatusTravelerAirshipMessage(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeStatusTravelerAirshipMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeStatusTravelerAirshipMessage>>
>;
export type ChangeStatusTravelerAirshipMessageMutationBody =
  UpdateStatusTravelerAirshipMessageRequest;
export type ChangeStatusTravelerAirshipMessageMutationError =
  ErrorType<unknown>;

/**
 * @summary changeStatusTravelerAirshipMessage
 */
export const useChangeStatusTravelerAirshipMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeStatusTravelerAirshipMessage>>,
    TError,
    { id: number; data: UpdateStatusTravelerAirshipMessageRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeStatusTravelerAirshipMessage>>,
  TError,
  { id: number; data: UpdateStatusTravelerAirshipMessageRequest },
  TContext
> => {
  const mutationOptions =
    getChangeStatusTravelerAirshipMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Verifica la cuenta del usuario VEE. Se recibe el código de verificación enviado al correo electrónico del usuario.
 * @summary verify-account
 */
export const verifyAccount = (verifyAccount: VerifyAccount) => {
  return instance<Success>({
    url: `/api/v1/auth/verify-account`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: verifyAccount,
  });
};

export const getVerifyAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyAccount>>,
    TError,
    { data: VerifyAccount },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyAccount>>,
  TError,
  { data: VerifyAccount },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyAccount>>,
    { data: VerifyAccount }
  > = (props) => {
    const { data } = props ?? {};

    return verifyAccount(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyAccount>>
>;
export type VerifyAccountMutationBody = VerifyAccount;
export type VerifyAccountMutationError = ErrorType<unknown>;

/**
 * @summary verify-account
 */
export const useVerifyAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyAccount>>,
    TError,
    { data: VerifyAccount },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyAccount>>,
  TError,
  { data: VerifyAccount },
  TContext
> => {
  const mutationOptions = getVerifyAccountMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Confirma el cambio de contraseña del usuario.
 * @summary confirm-forgot-password
 */
export const confirmForgotPassword = (
  confirmForgotPassword: ConfirmForgotPassword,
) => {
  return instance<Success>({
    url: `/api/v1/auth/confirm-forgot-password`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: confirmForgotPassword,
  });
};

export const getConfirmForgotPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmForgotPassword>>,
    TError,
    { data: ConfirmForgotPassword },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmForgotPassword>>,
  TError,
  { data: ConfirmForgotPassword },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmForgotPassword>>,
    { data: ConfirmForgotPassword }
  > = (props) => {
    const { data } = props ?? {};

    return confirmForgotPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmForgotPassword>>
>;
export type ConfirmForgotPasswordMutationBody = ConfirmForgotPassword;
export type ConfirmForgotPasswordMutationError = ErrorType<unknown>;

/**
 * @summary confirm-forgot-password
 */
export const useConfirmForgotPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmForgotPassword>>,
    TError,
    { data: ConfirmForgotPassword },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmForgotPassword>>,
  TError,
  { data: ConfirmForgotPassword },
  TContext
> => {
  const mutationOptions = getConfirmForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary change-password
 */
export const changePassword = (changePassword: ChangePassword) => {
  return instance<Success>({
    url: `/api/v1/auth/change-password`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: changePassword,
  });
};

export const getChangePasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: ChangePassword },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePassword },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: ChangePassword }
  > = (props) => {
    const { data } = props ?? {};

    return changePassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = ChangePassword;
export type ChangePasswordMutationError = ErrorType<unknown>;

/**
 * @summary change-password
 */
export const useChangePassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: ChangePassword },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePassword },
  TContext
> => {
  const mutationOptions = getChangePasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Obtiene las actividades favoritas con información de la actividad.
 * @summary getFavoriteActivitiesFromListWithPrice
 */
export const getFavoriteActivitiesFromListWithPrice = (
  id: number,
  params?: GetFavoriteActivitiesFromListWithPriceParams,
  signal?: AbortSignal,
) => {
  return instance<PageVmActivityDetailGeoSearch>({
    url: `/api/v1/activity/favorite/list/${id}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFavoriteActivitiesFromListWithPriceQueryKey = (
  id: number,
  params?: GetFavoriteActivitiesFromListWithPriceParams,
) => {
  return [
    `/api/v1/activity/favorite/list/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFavoriteActivitiesFromListWithPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavoriteActivitiesFromListWithPrice>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetFavoriteActivitiesFromListWithPriceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFavoriteActivitiesFromListWithPrice>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFavoriteActivitiesFromListWithPriceQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFavoriteActivitiesFromListWithPrice>>
  > = ({ signal }) =>
    getFavoriteActivitiesFromListWithPrice(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavoriteActivitiesFromListWithPrice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFavoriteActivitiesFromListWithPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavoriteActivitiesFromListWithPrice>>
>;
export type GetFavoriteActivitiesFromListWithPriceQueryError =
  ErrorType<unknown>;

/**
 * @summary getFavoriteActivitiesFromListWithPrice
 */
export const useGetFavoriteActivitiesFromListWithPrice = <
  TData = Awaited<ReturnType<typeof getFavoriteActivitiesFromListWithPrice>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetFavoriteActivitiesFromListWithPriceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFavoriteActivitiesFromListWithPrice>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFavoriteActivitiesFromListWithPriceQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Registra una actividad favorita.
 * @summary addFavoriteActivityToList
 */
export const addFavoriteActivityToList = (
  id: number,
  addActivityToFavoriteListRequest: AddActivityToFavoriteListRequest,
) => {
  return instance<Success>({
    url: `/api/v1/activity/favorite/list/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: addActivityToFavoriteListRequest,
  });
};

export const getAddFavoriteActivityToListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFavoriteActivityToList>>,
    TError,
    { id: number; data: AddActivityToFavoriteListRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addFavoriteActivityToList>>,
  TError,
  { id: number; data: AddActivityToFavoriteListRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addFavoriteActivityToList>>,
    { id: number; data: AddActivityToFavoriteListRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return addFavoriteActivityToList(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddFavoriteActivityToListMutationResult = NonNullable<
  Awaited<ReturnType<typeof addFavoriteActivityToList>>
>;
export type AddFavoriteActivityToListMutationBody =
  AddActivityToFavoriteListRequest;
export type AddFavoriteActivityToListMutationError = ErrorType<unknown>;

/**
 * @summary addFavoriteActivityToList
 */
export const useAddFavoriteActivityToList = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFavoriteActivityToList>>,
    TError,
    { id: number; data: AddActivityToFavoriteListRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addFavoriteActivityToList>>,
  TError,
  { id: number; data: AddActivityToFavoriteListRequest },
  TContext
> => {
  const mutationOptions = getAddFavoriteActivityToListMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Busca actividades por la distancia en metros de un punto dado y por días de la semana que se encuentren en un horario de la actividad.
 * @summary findByLocationV2
 */
export const findByLocationV2 = (
  params?: FindByLocationV2Params,
  signal?: AbortSignal,
) => {
  return instance<ActivityDetailGeoSearch[]>({
    url: `/api/v2/activity/find/location`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindByLocationV2QueryKey = (
  params?: FindByLocationV2Params,
) => {
  return [
    `/api/v2/activity/find/location`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindByLocationV2QueryOptions = <
  TData = Awaited<ReturnType<typeof findByLocationV2>>,
  TError = ErrorType<unknown>,
>(
  params?: FindByLocationV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findByLocationV2>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindByLocationV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findByLocationV2>>
  > = ({ signal }) => findByLocationV2(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findByLocationV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindByLocationV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof findByLocationV2>>
>;
export type FindByLocationV2QueryError = ErrorType<unknown>;

/**
 * @summary findByLocationV2
 */
export const useFindByLocationV2 = <
  TData = Awaited<ReturnType<typeof findByLocationV2>>,
  TError = ErrorType<unknown>,
>(
  params?: FindByLocationV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findByLocationV2>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindByLocationV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Regresa el catalogo de Tags.
 * @summary getTags
 */
export const getTags = (signal?: AbortSignal) => {
  return instance<ActivityTag[]>({
    url: `/api/v1/support/tags`,
    method: "GET",
    signal,
  });
};

export const getGetTagsQueryKey = () => {
  return [`/api/v1/support/tags`] as const;
};

export const getGetTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTags>>> = ({
    signal,
  }) => getTags(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTags>>
>;
export type GetTagsQueryError = ErrorType<unknown>;

/**
 * @summary getTags
 */
export const useGetTags = <
  TData = Awaited<ReturnType<typeof getTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * validar slug
 * @summary getActivityIdBySlug
 */
export const getActivityIdBySlug = (slug: string, signal?: AbortSignal) => {
  return instance<ActivityBySlugDto>({
    url: `/api/v1/support/slug/${slug}`,
    method: "GET",
    signal,
  });
};

export const getGetActivityIdBySlugQueryKey = (slug: string) => {
  return [`/api/v1/support/slug/${slug}`] as const;
};

export const getGetActivityIdBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivityIdBySlug>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityIdBySlug>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActivityIdBySlugQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivityIdBySlug>>
  > = ({ signal }) => getActivityIdBySlug(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivityIdBySlug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActivityIdBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivityIdBySlug>>
>;
export type GetActivityIdBySlugQueryError = ErrorType<unknown>;

/**
 * @summary getActivityIdBySlug
 */
export const useGetActivityIdBySlug = <
  TData = Awaited<ReturnType<typeof getActivityIdBySlug>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityIdBySlug>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActivityIdBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Busqueda de categorias y subcategorias por nombre
 * @summary searchCategoryAndSubcategoryByName
 */
export const searchCategoryAndSubcategoryByName = (
  params: SearchCategoryAndSubcategoryByNameParams,
  signal?: AbortSignal,
) => {
  return instance<string[]>({
    url: `/api/v1/support/search`,
    method: "GET",
    params,
    signal,
  });
};

export const getSearchCategoryAndSubcategoryByNameQueryKey = (
  params: SearchCategoryAndSubcategoryByNameParams,
) => {
  return [`/api/v1/support/search`, ...(params ? [params] : [])] as const;
};

export const getSearchCategoryAndSubcategoryByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof searchCategoryAndSubcategoryByName>>,
  TError = ErrorType<unknown>,
>(
  params: SearchCategoryAndSubcategoryByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchCategoryAndSubcategoryByName>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchCategoryAndSubcategoryByNameQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchCategoryAndSubcategoryByName>>
  > = ({ signal }) => searchCategoryAndSubcategoryByName(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchCategoryAndSubcategoryByName>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchCategoryAndSubcategoryByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchCategoryAndSubcategoryByName>>
>;
export type SearchCategoryAndSubcategoryByNameQueryError = ErrorType<unknown>;

/**
 * @summary searchCategoryAndSubcategoryByName
 */
export const useSearchCategoryAndSubcategoryByName = <
  TData = Awaited<ReturnType<typeof searchCategoryAndSubcategoryByName>>,
  TError = ErrorType<unknown>,
>(
  params: SearchCategoryAndSubcategoryByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchCategoryAndSubcategoryByName>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchCategoryAndSubcategoryByNameQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene provincias por nombre
 * @summary findProvinceByName
 */
export const findProvinceByName = (
  params: FindProvinceByNameParams,
  signal?: AbortSignal,
) => {
  return instance<ProvinceTableDto[]>({
    url: `/api/v1/support/search/provinces`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindProvinceByNameQueryKey = (
  params: FindProvinceByNameParams,
) => {
  return [
    `/api/v1/support/search/provinces`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindProvinceByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof findProvinceByName>>,
  TError = ErrorType<unknown>,
>(
  params: FindProvinceByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findProvinceByName>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindProvinceByNameQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findProvinceByName>>
  > = ({ signal }) => findProvinceByName(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findProvinceByName>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindProvinceByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof findProvinceByName>>
>;
export type FindProvinceByNameQueryError = ErrorType<unknown>;

/**
 * @summary findProvinceByName
 */
export const useFindProvinceByName = <
  TData = Awaited<ReturnType<typeof findProvinceByName>>,
  TError = ErrorType<unknown>,
>(
  params: FindProvinceByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findProvinceByName>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindProvinceByNameQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene comunidades por nombre
 * @summary findCommunityByName
 */
export const findCommunityByName = (
  params: FindCommunityByNameParams,
  signal?: AbortSignal,
) => {
  return instance<Community[]>({
    url: `/api/v1/support/search/communities`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindCommunityByNameQueryKey = (
  params: FindCommunityByNameParams,
) => {
  return [
    `/api/v1/support/search/communities`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindCommunityByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof findCommunityByName>>,
  TError = ErrorType<unknown>,
>(
  params: FindCommunityByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findCommunityByName>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindCommunityByNameQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findCommunityByName>>
  > = ({ signal }) => findCommunityByName(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findCommunityByName>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindCommunityByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof findCommunityByName>>
>;
export type FindCommunityByNameQueryError = ErrorType<unknown>;

/**
 * @summary findCommunityByName
 */
export const useFindCommunityByName = <
  TData = Awaited<ReturnType<typeof findCommunityByName>>,
  TError = ErrorType<unknown>,
>(
  params: FindCommunityByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findCommunityByName>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindCommunityByNameQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene ciudades por nombre
 * @summary findCityByName
 */
export const findCityByName = (
  params: FindCityByNameParams,
  signal?: AbortSignal,
) => {
  return instance<CityDto[]>({
    url: `/api/v1/support/search/cities`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindCityByNameQueryKey = (params: FindCityByNameParams) => {
  return [
    `/api/v1/support/search/cities`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindCityByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof findCityByName>>,
  TError = ErrorType<unknown>,
>(
  params: FindCityByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findCityByName>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindCityByNameQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findCityByName>>> = ({
    signal,
  }) => findCityByName(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findCityByName>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindCityByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof findCityByName>>
>;
export type FindCityByNameQueryError = ErrorType<unknown>;

/**
 * @summary findCityByName
 */
export const useFindCityByName = <
  TData = Awaited<ReturnType<typeof findCityByName>>,
  TError = ErrorType<unknown>,
>(
  params: FindCityByNameParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findCityByName>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindCityByNameQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene ciudades por nombre
 * @summary searchCitiesByNameTerm
 */
export const searchCitiesByNameTerm = (
  params: SearchCitiesByNameTermParams,
  signal?: AbortSignal,
) => {
  return instance<CityDto[]>({
    url: `/api/v1/support/search/cities/term`,
    method: "GET",
    params,
    signal,
  });
};

export const getSearchCitiesByNameTermQueryKey = (
  params: SearchCitiesByNameTermParams,
) => {
  return [
    `/api/v1/support/search/cities/term`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchCitiesByNameTermQueryOptions = <
  TData = Awaited<ReturnType<typeof searchCitiesByNameTerm>>,
  TError = ErrorType<unknown>,
>(
  params: SearchCitiesByNameTermParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchCitiesByNameTerm>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchCitiesByNameTermQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchCitiesByNameTerm>>
  > = ({ signal }) => searchCitiesByNameTerm(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchCitiesByNameTerm>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchCitiesByNameTermQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchCitiesByNameTerm>>
>;
export type SearchCitiesByNameTermQueryError = ErrorType<unknown>;

/**
 * @summary searchCitiesByNameTerm
 */
export const useSearchCitiesByNameTerm = <
  TData = Awaited<ReturnType<typeof searchCitiesByNameTerm>>,
  TError = ErrorType<unknown>,
>(
  params: SearchCitiesByNameTermParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchCitiesByNameTerm>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchCitiesByNameTermQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene el catálogo de comunidades
 * @summary findProvincesByCommunity
 */
export const findProvincesByCommunity = (
  community: string,
  signal?: AbortSignal,
) => {
  return instance<Province[]>({
    url: `/api/v1/support/region/community/${community}/provinces`,
    method: "GET",
    signal,
  });
};

export const getFindProvincesByCommunityQueryKey = (community: string) => {
  return [`/api/v1/support/region/community/${community}/provinces`] as const;
};

export const getFindProvincesByCommunityQueryOptions = <
  TData = Awaited<ReturnType<typeof findProvincesByCommunity>>,
  TError = ErrorType<unknown>,
>(
  community: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findProvincesByCommunity>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindProvincesByCommunityQueryKey(community);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findProvincesByCommunity>>
  > = ({ signal }) => findProvincesByCommunity(community, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!community,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findProvincesByCommunity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindProvincesByCommunityQueryResult = NonNullable<
  Awaited<ReturnType<typeof findProvincesByCommunity>>
>;
export type FindProvincesByCommunityQueryError = ErrorType<unknown>;

/**
 * @summary findProvincesByCommunity
 */
export const useFindProvincesByCommunity = <
  TData = Awaited<ReturnType<typeof findProvincesByCommunity>>,
  TError = ErrorType<unknown>,
>(
  community: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findProvincesByCommunity>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindProvincesByCommunityQueryOptions(
    community,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene ciudades por nombre
 * @summary getCitiesByCommunity
 */
export const getCitiesByCommunity = (
  communityId: string,
  signal?: AbortSignal,
) => {
  return instance<CityDto[]>({
    url: `/api/v1/support/region/community/${communityId}/cities`,
    method: "GET",
    signal,
  });
};

export const getGetCitiesByCommunityQueryKey = (communityId: string) => {
  return [`/api/v1/support/region/community/${communityId}/cities`] as const;
};

export const getGetCitiesByCommunityQueryOptions = <
  TData = Awaited<ReturnType<typeof getCitiesByCommunity>>,
  TError = ErrorType<unknown>,
>(
  communityId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCitiesByCommunity>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCitiesByCommunityQueryKey(communityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCitiesByCommunity>>
  > = ({ signal }) => getCitiesByCommunity(communityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!communityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCitiesByCommunity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCitiesByCommunityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCitiesByCommunity>>
>;
export type GetCitiesByCommunityQueryError = ErrorType<unknown>;

/**
 * @summary getCitiesByCommunity
 */
export const useGetCitiesByCommunity = <
  TData = Awaited<ReturnType<typeof getCitiesByCommunity>>,
  TError = ErrorType<unknown>,
>(
  communityId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCitiesByCommunity>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCitiesByCommunityQueryOptions(
    communityId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene el catálogo de comunidades
 * @summary findAllCommunities
 */
export const findAllCommunities = (signal?: AbortSignal) => {
  return instance<Community[]>({
    url: `/api/v1/support/region/communities`,
    method: "GET",
    signal,
  });
};

export const getFindAllCommunitiesQueryKey = () => {
  return [`/api/v1/support/region/communities`] as const;
};

export const getFindAllCommunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof findAllCommunities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof findAllCommunities>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindAllCommunitiesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findAllCommunities>>
  > = ({ signal }) => findAllCommunities(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findAllCommunities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindAllCommunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof findAllCommunities>>
>;
export type FindAllCommunitiesQueryError = ErrorType<unknown>;

/**
 * @summary findAllCommunities
 */
export const useFindAllCommunities = <
  TData = Awaited<ReturnType<typeof findAllCommunities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof findAllCommunities>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindAllCommunitiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Regresa el catalogo de movilidad.
 * @summary getMobilityOptions
 */
export const getMobilityOptions = (signal?: AbortSignal) => {
  return instance<ActivityMobilityVm[]>({
    url: `/api/v1/support/mobility`,
    method: "GET",
    signal,
  });
};

export const getGetMobilityOptionsQueryKey = () => {
  return [`/api/v1/support/mobility`] as const;
};

export const getGetMobilityOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobilityOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMobilityOptions>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobilityOptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMobilityOptions>>
  > = ({ signal }) => getMobilityOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMobilityOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMobilityOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMobilityOptions>>
>;
export type GetMobilityOptionsQueryError = ErrorType<unknown>;

/**
 * @summary getMobilityOptions
 */
export const useGetMobilityOptions = <
  TData = Awaited<ReturnType<typeof getMobilityOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMobilityOptions>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMobilityOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene los idiomas de la plataforma.
 * @summary getLanguages
 */
export const getLanguages = (signal?: AbortSignal) => {
  return instance<ActivityLanguage[]>({
    url: `/api/v1/support/languages`,
    method: "GET",
    signal,
  });
};

export const getGetLanguagesQueryKey = () => {
  return [`/api/v1/support/languages`] as const;
};

export const getGetLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLanguages>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLanguagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguages>>> = ({
    signal,
  }) => getLanguages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLanguages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLanguagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLanguages>>
>;
export type GetLanguagesQueryError = ErrorType<unknown>;

/**
 * @summary getLanguages
 */
export const useGetLanguages = <
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLanguages>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLanguagesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permite obtener las sub-categorías dadas de alta de una categoría
 * @summary findSubcategoryByCategory
 */
export const findSubcategoryByCategory = (
  categoryId: number,
  signal?: AbortSignal,
) => {
  return instance<Subcategory[]>({
    url: `/api/v1/support/category/${categoryId}/sub-categories`,
    method: "GET",
    signal,
  });
};

export const getFindSubcategoryByCategoryQueryKey = (categoryId: number) => {
  return [`/api/v1/support/category/${categoryId}/sub-categories`] as const;
};

export const getFindSubcategoryByCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof findSubcategoryByCategory>>,
  TError = ErrorType<unknown>,
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findSubcategoryByCategory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindSubcategoryByCategoryQueryKey(categoryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findSubcategoryByCategory>>
  > = ({ signal }) => findSubcategoryByCategory(categoryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!categoryId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findSubcategoryByCategory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindSubcategoryByCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSubcategoryByCategory>>
>;
export type FindSubcategoryByCategoryQueryError = ErrorType<unknown>;

/**
 * @summary findSubcategoryByCategory
 */
export const useFindSubcategoryByCategory = <
  TData = Awaited<ReturnType<typeof findSubcategoryByCategory>>,
  TError = ErrorType<unknown>,
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findSubcategoryByCategory>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindSubcategoryByCategoryQueryOptions(
    categoryId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permite obtener las categorías dadas de alta
 * @summary findAllCategory
 */
export const findAllCategory = (signal?: AbortSignal) => {
  return instance<Category[]>({
    url: `/api/v1/support/categories`,
    method: "GET",
    signal,
  });
};

export const getFindAllCategoryQueryKey = () => {
  return [`/api/v1/support/categories`] as const;
};

export const getFindAllCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof findAllCategory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof findAllCategory>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindAllCategoryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllCategory>>> = ({
    signal,
  }) => findAllCategory(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findAllCategory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindAllCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof findAllCategory>>
>;
export type FindAllCategoryQueryError = ErrorType<unknown>;

/**
 * @summary findAllCategory
 */
export const useFindAllCategory = <
  TData = Awaited<ReturnType<typeof findAllCategory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof findAllCategory>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindAllCategoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary signIn
 */
export const signIn1 = (params: SignIn1Params, signal?: AbortSignal) => {
  return instance<AccessToken>({
    url: `/api/v1/social-login/`,
    method: "GET",
    params,
    signal,
  });
};

export const getSignIn1QueryKey = (params: SignIn1Params) => {
  return [`/api/v1/social-login/`, ...(params ? [params] : [])] as const;
};

export const getSignIn1QueryOptions = <
  TData = Awaited<ReturnType<typeof signIn1>>,
  TError = ErrorType<unknown>,
>(
  params: SignIn1Params,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof signIn1>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSignIn1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof signIn1>>> = ({
    signal,
  }) => signIn1(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof signIn1>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SignIn1QueryResult = NonNullable<
  Awaited<ReturnType<typeof signIn1>>
>;
export type SignIn1QueryError = ErrorType<unknown>;

/**
 * @summary signIn
 */
export const useSignIn1 = <
  TData = Awaited<ReturnType<typeof signIn1>>,
  TError = ErrorType<unknown>,
>(
  params: SignIn1Params,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof signIn1>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSignIn1QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la lista de reservaciones por estatus que estén ligadas al viajero.
 * @summary getReservations
 */
export const getReservations = (
  params: GetReservationsParams,
  signal?: AbortSignal,
) => {
  return instance<PageVmReservationInfoVm>({
    url: `/api/v1/reservation`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetReservationsQueryKey = (params: GetReservationsParams) => {
  return [`/api/v1/reservation`, ...(params ? [params] : [])] as const;
};

export const getGetReservationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReservations>>,
  TError = ErrorType<unknown>,
>(
  params: GetReservationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReservations>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReservationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReservations>>> = ({
    signal,
  }) => getReservations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReservations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReservationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReservations>>
>;
export type GetReservationsQueryError = ErrorType<unknown>;

/**
 * @summary getReservations
 */
export const useGetReservations = <
  TData = Awaited<ReturnType<typeof getReservations>>,
  TError = ErrorType<unknown>,
>(
  params: GetReservationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReservations>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetReservationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de los términos y condiciones de la actividad para una reserva.
 * @summary getTermsAndConditions
 */
export const getTermsAndConditions = (id: number, signal?: AbortSignal) => {
  return instance<ActivityTermsAndConditionsVm>({
    url: `/api/v1/reservation/${id}/terms-and-conditions`,
    method: "GET",
    signal,
  });
};

export const getGetTermsAndConditionsQueryKey = (id: number) => {
  return [`/api/v1/reservation/${id}/terms-and-conditions`] as const;
};

export const getGetTermsAndConditionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTermsAndConditions>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditions>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTermsAndConditionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTermsAndConditions>>
  > = ({ signal }) => getTermsAndConditions(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTermsAndConditions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTermsAndConditionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTermsAndConditions>>
>;
export type GetTermsAndConditionsQueryError = ErrorType<unknown>;

/**
 * @summary getTermsAndConditions
 */
export const useGetTermsAndConditions = <
  TData = Awaited<ReturnType<typeof getTermsAndConditions>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditions>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTermsAndConditionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de la reservación.
 * @summary getDetailInformation
 */
export const getDetailInformation = (id: number, signal?: AbortSignal) => {
  return instance<ReservationInfoDetailVm>({
    url: `/api/v1/reservation/${id}/detail`,
    method: "GET",
    signal,
  });
};

export const getGetDetailInformationQueryKey = (id: number) => {
  return [`/api/v1/reservation/${id}/detail`] as const;
};

export const getGetDetailInformationQueryOptions = <
  TData = Awaited<ReturnType<typeof getDetailInformation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDetailInformation>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDetailInformationQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDetailInformation>>
  > = ({ signal }) => getDetailInformation(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDetailInformation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDetailInformationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDetailInformation>>
>;
export type GetDetailInformationQueryError = ErrorType<unknown>;

/**
 * @summary getDetailInformation
 */
export const useGetDetailInformation = <
  TData = Awaited<ReturnType<typeof getDetailInformation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDetailInformation>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDetailInformationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la localización de la actividad para una reserva.
 * @summary getActivityLocation
 */
export const getActivityLocation = (id: number, signal?: AbortSignal) => {
  return instance<ActivityAddressVm>({
    url: `/api/v1/reservation/${id}/activity/location`,
    method: "GET",
    signal,
  });
};

export const getGetActivityLocationQueryKey = (id: number) => {
  return [`/api/v1/reservation/${id}/activity/location`] as const;
};

export const getGetActivityLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivityLocation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityLocation>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActivityLocationQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivityLocation>>
  > = ({ signal }) => getActivityLocation(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivityLocation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActivityLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivityLocation>>
>;
export type GetActivityLocationQueryError = ErrorType<unknown>;

/**
 * @summary getActivityLocation
 */
export const useGetActivityLocation = <
  TData = Awaited<ReturnType<typeof getActivityLocation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityLocation>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActivityLocationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de detalle de la actividad para una reserva.
 * @summary getActivityDetail
 */
export const getActivityDetail = (id: number, signal?: AbortSignal) => {
  return instance<ActivityDetailVm>({
    url: `/api/v1/reservation/${id}/activity/detail`,
    method: "GET",
    signal,
  });
};

export const getGetActivityDetailQueryKey = (id: number) => {
  return [`/api/v1/reservation/${id}/activity/detail`] as const;
};

export const getGetActivityDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivityDetail>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityDetail>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActivityDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivityDetail>>
  > = ({ signal }) => getActivityDetail(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivityDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActivityDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivityDetail>>
>;
export type GetActivityDetailQueryError = ErrorType<unknown>;

/**
 * @summary getActivityDetail
 */
export const useGetActivityDetail = <
  TData = Awaited<ReturnType<typeof getActivityDetail>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityDetail>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActivityDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la descripción de la actividad para una reserva.
 * @summary getActivityDescription
 */
export const getActivityDescription = (id: number, signal?: AbortSignal) => {
  return instance<ActivityBasicInfoVm>({
    url: `/api/v1/reservation/${id}/activity/description`,
    method: "GET",
    signal,
  });
};

export const getGetActivityDescriptionQueryKey = (id: number) => {
  return [`/api/v1/reservation/${id}/activity/description`] as const;
};

export const getGetActivityDescriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivityDescription>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityDescription>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActivityDescriptionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivityDescription>>
  > = ({ signal }) => getActivityDescription(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivityDescription>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActivityDescriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivityDescription>>
>;
export type GetActivityDescriptionQueryError = ErrorType<unknown>;

/**
 * @summary getActivityDescription
 */
export const useGetActivityDescription = <
  TData = Awaited<ReturnType<typeof getActivityDescription>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityDescription>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActivityDescriptionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene los metodos de pago del traveler.
 * @summary getTravelerPayments
 */
export const getTravelerPayments = (signal?: AbortSignal) => {
  return instance<PaymentMethodVm[]>({
    url: `/api/v1/profile/payment-method/list`,
    method: "GET",
    signal,
  });
};

export const getGetTravelerPaymentsQueryKey = () => {
  return [`/api/v1/profile/payment-method/list`] as const;
};

export const getGetTravelerPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTravelerPayments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTravelerPayments>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTravelerPaymentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTravelerPayments>>
  > = ({ signal }) => getTravelerPayments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTravelerPayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTravelerPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTravelerPayments>>
>;
export type GetTravelerPaymentsQueryError = ErrorType<unknown>;

/**
 * @summary getTravelerPayments
 */
export const useGetTravelerPayments = <
  TData = Awaited<ReturnType<typeof getTravelerPayments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTravelerPayments>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTravelerPaymentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Indica si el usuario ya aceptó los términos y condiciones.
 * @deprecated
 * @summary isTermsAndConditionsAccepted
 */
export const isTermsAndConditionsAccepted = (signal?: AbortSignal) => {
  return instance<AcceptedTyCVm>({
    url: `/api/v1/profile/is-tyc-accepted`,
    method: "GET",
    signal,
  });
};

export const getIsTermsAndConditionsAcceptedQueryKey = () => {
  return [`/api/v1/profile/is-tyc-accepted`] as const;
};

export const getIsTermsAndConditionsAcceptedQueryOptions = <
  TData = Awaited<ReturnType<typeof isTermsAndConditionsAccepted>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof isTermsAndConditionsAccepted>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getIsTermsAndConditionsAcceptedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof isTermsAndConditionsAccepted>>
  > = ({ signal }) => isTermsAndConditionsAccepted(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isTermsAndConditionsAccepted>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type IsTermsAndConditionsAcceptedQueryResult = NonNullable<
  Awaited<ReturnType<typeof isTermsAndConditionsAccepted>>
>;
export type IsTermsAndConditionsAcceptedQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary isTermsAndConditionsAccepted
 */
export const useIsTermsAndConditionsAccepted = <
  TData = Awaited<ReturnType<typeof isTermsAndConditionsAccepted>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof isTermsAndConditionsAccepted>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getIsTermsAndConditionsAcceptedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Regresa la información general del viajero.
 * @summary getOnlyGeneralInfo
 */
export const getOnlyGeneralInfo = (signal?: AbortSignal) => {
  return instance<TravelerVm>({
    url: `/api/v1/profile/general-info`,
    method: "GET",
    signal,
  });
};

export const getGetOnlyGeneralInfoQueryKey = () => {
  return [`/api/v1/profile/general-info`] as const;
};

export const getGetOnlyGeneralInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getOnlyGeneralInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOnlyGeneralInfo>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOnlyGeneralInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOnlyGeneralInfo>>
  > = ({ signal }) => getOnlyGeneralInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOnlyGeneralInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOnlyGeneralInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOnlyGeneralInfo>>
>;
export type GetOnlyGeneralInfoQueryError = ErrorType<unknown>;

/**
 * @summary getOnlyGeneralInfo
 */
export const useGetOnlyGeneralInfo = <
  TData = Awaited<ReturnType<typeof getOnlyGeneralInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOnlyGeneralInfo>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOnlyGeneralInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Regresa la información general del viajero.
 * @summary getGeneralInfoWithFirebaseToken
 */
export const getGeneralInfoWithFirebaseToken = (signal?: AbortSignal) => {
  return instance<TravelerVm>({
    url: `/api/v1/profile/general-info-firebase`,
    method: "GET",
    signal,
  });
};

export const getGetGeneralInfoWithFirebaseTokenQueryKey = () => {
  return [`/api/v1/profile/general-info-firebase`] as const;
};

export const getGetGeneralInfoWithFirebaseTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneralInfoWithFirebaseToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneralInfoWithFirebaseToken>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeneralInfoWithFirebaseTokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeneralInfoWithFirebaseToken>>
  > = ({ signal }) => getGeneralInfoWithFirebaseToken(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneralInfoWithFirebaseToken>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneralInfoWithFirebaseTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneralInfoWithFirebaseToken>>
>;
export type GetGeneralInfoWithFirebaseTokenQueryError = ErrorType<unknown>;

/**
 * @summary getGeneralInfoWithFirebaseToken
 */
export const useGetGeneralInfoWithFirebaseToken = <
  TData = Awaited<ReturnType<typeof getGeneralInfoWithFirebaseToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneralInfoWithFirebaseToken>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeneralInfoWithFirebaseTokenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Regresa la información general del viajero.
 * @summary getOnlyFirebaseToken
 */
export const getOnlyFirebaseToken = (signal?: AbortSignal) => {
  return instance<string>({
    url: `/api/v1/profile/firebase-token`,
    method: "GET",
    signal,
  });
};

export const getGetOnlyFirebaseTokenQueryKey = () => {
  return [`/api/v1/profile/firebase-token`] as const;
};

export const getGetOnlyFirebaseTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getOnlyFirebaseToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOnlyFirebaseToken>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOnlyFirebaseTokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOnlyFirebaseToken>>
  > = ({ signal }) => getOnlyFirebaseToken(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOnlyFirebaseToken>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOnlyFirebaseTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOnlyFirebaseToken>>
>;
export type GetOnlyFirebaseTokenQueryError = ErrorType<unknown>;

/**
 * @summary getOnlyFirebaseToken
 */
export const useGetOnlyFirebaseToken = <
  TData = Awaited<ReturnType<typeof getOnlyFirebaseToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOnlyFirebaseToken>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOnlyFirebaseTokenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de las opciones adicionales para la tarifa.
 * @deprecated
 * @summary getCustomFieldsByTariff
 */
export const getCustomFieldsByTariff = (
  tariffId: number,
  signal?: AbortSignal,
) => {
  return instance<CustomField[]>({
    url: `/api/v1/fareharbor/custom-fields/tariff/${tariffId}`,
    method: "GET",
    signal,
  });
};

export const getGetCustomFieldsByTariffQueryKey = (tariffId: number) => {
  return [`/api/v1/fareharbor/custom-fields/tariff/${tariffId}`] as const;
};

export const getGetCustomFieldsByTariffQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomFieldsByTariff>>,
  TError = ErrorType<unknown>,
>(
  tariffId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsByTariff>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomFieldsByTariffQueryKey(tariffId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomFieldsByTariff>>
  > = ({ signal }) => getCustomFieldsByTariff(tariffId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tariffId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomFieldsByTariff>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomFieldsByTariffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomFieldsByTariff>>
>;
export type GetCustomFieldsByTariffQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary getCustomFieldsByTariff
 */
export const useGetCustomFieldsByTariff = <
  TData = Awaited<ReturnType<typeof getCustomFieldsByTariff>>,
  TError = ErrorType<unknown>,
>(
  tariffId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsByTariff>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomFieldsByTariffQueryOptions(
    tariffId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de las opciones adicionales para la tarifa.
 * @deprecated
 * @summary getCustomFieldsByTariffAndAudience
 */
export const getCustomFieldsByTariffAndAudience = (
  tariffId: number,
  audienceId: number,
  signal?: AbortSignal,
) => {
  return instance<CustomField[]>({
    url: `/api/v1/fareharbor/custom-fields/tariff/${tariffId}/audience/${audienceId}`,
    method: "GET",
    signal,
  });
};

export const getGetCustomFieldsByTariffAndAudienceQueryKey = (
  tariffId: number,
  audienceId: number,
) => {
  return [
    `/api/v1/fareharbor/custom-fields/tariff/${tariffId}/audience/${audienceId}`,
  ] as const;
};

export const getGetCustomFieldsByTariffAndAudienceQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudience>>,
  TError = ErrorType<unknown>,
>(
  tariffId: number,
  audienceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudience>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomFieldsByTariffAndAudienceQueryKey(tariffId, audienceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudience>>
  > = ({ signal }) =>
    getCustomFieldsByTariffAndAudience(tariffId, audienceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(tariffId && audienceId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudience>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomFieldsByTariffAndAudienceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudience>>
>;
export type GetCustomFieldsByTariffAndAudienceQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary getCustomFieldsByTariffAndAudience
 */
export const useGetCustomFieldsByTariffAndAudience = <
  TData = Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudience>>,
  TError = ErrorType<unknown>,
>(
  tariffId: number,
  audienceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudience>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomFieldsByTariffAndAudienceQueryOptions(
    tariffId,
    audienceId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de las opciones adicionales el horario de la actividad.
 * @deprecated
 * @summary getCustomFieldsBySchedule
 */
export const getCustomFieldsBySchedule = (
  scheduleId: number,
  signal?: AbortSignal,
) => {
  return instance<CustomField[]>({
    url: `/api/v1/fareharbor/custom-fields/schedule/${scheduleId}`,
    method: "GET",
    signal,
  });
};

export const getGetCustomFieldsByScheduleQueryKey = (scheduleId: number) => {
  return [`/api/v1/fareharbor/custom-fields/schedule/${scheduleId}`] as const;
};

export const getGetCustomFieldsByScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomFieldsBySchedule>>,
  TError = ErrorType<unknown>,
>(
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsBySchedule>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomFieldsByScheduleQueryKey(scheduleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomFieldsBySchedule>>
  > = ({ signal }) => getCustomFieldsBySchedule(scheduleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!scheduleId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomFieldsBySchedule>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomFieldsByScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomFieldsBySchedule>>
>;
export type GetCustomFieldsByScheduleQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary getCustomFieldsBySchedule
 */
export const useGetCustomFieldsBySchedule = <
  TData = Awaited<ReturnType<typeof getCustomFieldsBySchedule>>,
  TError = ErrorType<unknown>,
>(
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsBySchedule>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomFieldsByScheduleQueryOptions(
    scheduleId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de las opciones adicionales para la tarifa.
 * @summary getCustomFieldsByTariffAndAudienceAndActivityId
 */
export const getCustomFieldsByTariffAndAudienceAndActivityId = (
  activityId: number,
  tariffId: number,
  audienceId: number,
  signal?: AbortSignal,
) => {
  return instance<CustomField[]>({
    url: `/api/v1/fareharbor/activity/${activityId}/custom-fields/tariff/${tariffId}/audience/${audienceId}`,
    method: "GET",
    signal,
  });
};

export const getGetCustomFieldsByTariffAndAudienceAndActivityIdQueryKey = (
  activityId: number,
  tariffId: number,
  audienceId: number,
) => {
  return [
    `/api/v1/fareharbor/activity/${activityId}/custom-fields/tariff/${tariffId}/audience/${audienceId}`,
  ] as const;
};

export const getGetCustomFieldsByTariffAndAudienceAndActivityIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getCustomFieldsByTariffAndAudienceAndActivityId>
  >,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  tariffId: number,
  audienceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getCustomFieldsByTariffAndAudienceAndActivityId>
      >,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomFieldsByTariffAndAudienceAndActivityIdQueryKey(
      activityId,
      tariffId,
      audienceId,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudienceAndActivityId>>
  > = ({ signal }) =>
    getCustomFieldsByTariffAndAudienceAndActivityId(
      activityId,
      tariffId,
      audienceId,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(activityId && tariffId && audienceId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudienceAndActivityId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomFieldsByTariffAndAudienceAndActivityIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getCustomFieldsByTariffAndAudienceAndActivityId>>
  >;
export type GetCustomFieldsByTariffAndAudienceAndActivityIdQueryError =
  ErrorType<unknown>;

/**
 * @summary getCustomFieldsByTariffAndAudienceAndActivityId
 */
export const useGetCustomFieldsByTariffAndAudienceAndActivityId = <
  TData = Awaited<
    ReturnType<typeof getCustomFieldsByTariffAndAudienceAndActivityId>
  >,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  tariffId: number,
  audienceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getCustomFieldsByTariffAndAudienceAndActivityId>
      >,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetCustomFieldsByTariffAndAudienceAndActivityIdQueryOptions(
      activityId,
      tariffId,
      audienceId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de las opciones adicionales el horario de la actividad.
 * @summary getCustomFieldsByScheduleAndActivityId
 */
export const getCustomFieldsByScheduleAndActivityId = (
  activityId: number,
  scheduleId: number,
  signal?: AbortSignal,
) => {
  return instance<CustomField[]>({
    url: `/api/v1/fareharbor/activity/${activityId}/custom-fields/schedule/${scheduleId}`,
    method: "GET",
    signal,
  });
};

export const getGetCustomFieldsByScheduleAndActivityIdQueryKey = (
  activityId: number,
  scheduleId: number,
) => {
  return [
    `/api/v1/fareharbor/activity/${activityId}/custom-fields/schedule/${scheduleId}`,
  ] as const;
};

export const getGetCustomFieldsByScheduleAndActivityIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomFieldsByScheduleAndActivityId>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsByScheduleAndActivityId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomFieldsByScheduleAndActivityIdQueryKey(activityId, scheduleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomFieldsByScheduleAndActivityId>>
  > = ({ signal }) =>
    getCustomFieldsByScheduleAndActivityId(activityId, scheduleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(activityId && scheduleId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomFieldsByScheduleAndActivityId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomFieldsByScheduleAndActivityIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomFieldsByScheduleAndActivityId>>
>;
export type GetCustomFieldsByScheduleAndActivityIdQueryError =
  ErrorType<unknown>;

/**
 * @summary getCustomFieldsByScheduleAndActivityId
 */
export const useGetCustomFieldsByScheduleAndActivityId = <
  TData = Awaited<ReturnType<typeof getCustomFieldsByScheduleAndActivityId>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomFieldsByScheduleAndActivityId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomFieldsByScheduleAndActivityIdQueryOptions(
    activityId,
    scheduleId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de los retos
 * @summary getChallenges
 */
export const getChallenge = (
  params?: GetChallengeParams,
  signal?: AbortSignal,
) => {
  return instance<PageVmChallengeVm>({
    url: `/api/v1/challenge/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetChallengeQueryKey = (params?: GetChallengeParams) => {
  return [`/api/v1/challenge/`, ...(params ? [params] : [])] as const;
};

export const getGetChallengeQueryOptions = <
  TData = Awaited<ReturnType<typeof getChallenge>>,
  TError = ErrorType<unknown>,
>(
  params?: GetChallengeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChallenge>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChallengeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChallenge>>> = ({
    signal,
  }) => getChallenge(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChallenge>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChallengeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChallenge>>
>;
export type GetChallengeQueryError = ErrorType<unknown>;

/**
 * @summary getChallenges
 */
export const useGetChallenge = <
  TData = Awaited<ReturnType<typeof getChallenge>>,
  TError = ErrorType<unknown>,
>(
  params?: GetChallengeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChallenge>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChallengeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene la información de los movimientos de los puntos de cashback
 * @summary getHistory
 */
export const getHistory = (params?: GetHistoryParams, signal?: AbortSignal) => {
  return instance<PageVmCashbackHistoryVm>({
    url: `/api/v1/cashback/history`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetHistoryQueryKey = (params?: GetHistoryParams) => {
  return [`/api/v1/cashback/history`, ...(params ? [params] : [])] as const;
};

export const getGetHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHistory>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHistory>>> = ({
    signal,
  }) => getHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHistory>>
>;
export type GetHistoryQueryError = ErrorType<unknown>;

/**
 * @summary getHistory
 */
export const useGetHistory = <
  TData = Awaited<ReturnType<typeof getHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHistory>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra la información de horarios de una actividad por mes
 * @summary getAvailabilityDatesByMonth
 */
export const getAvailabilityDatesByMonth = (
  activityId: number,
  year: number,
  month: number,
  signal?: AbortSignal,
) => {
  return instance<AvailabilityDatesVm>({
    url: `/api/v1/activity/${activityId}/year/${year}/month/${month}/dates-available`,
    method: "GET",
    signal,
  });
};

export const getGetAvailabilityDatesByMonthQueryKey = (
  activityId: number,
  year: number,
  month: number,
) => {
  return [
    `/api/v1/activity/${activityId}/year/${year}/month/${month}/dates-available`,
  ] as const;
};

export const getGetAvailabilityDatesByMonthQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailabilityDatesByMonth>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  year: number,
  month: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailabilityDatesByMonth>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAvailabilityDatesByMonthQueryKey(activityId, year, month);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailabilityDatesByMonth>>
  > = ({ signal }) =>
    getAvailabilityDatesByMonth(activityId, year, month, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(activityId && year && month),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailabilityDatesByMonth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAvailabilityDatesByMonthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailabilityDatesByMonth>>
>;
export type GetAvailabilityDatesByMonthQueryError = ErrorType<unknown>;

/**
 * @summary getAvailabilityDatesByMonth
 */
export const useGetAvailabilityDatesByMonth = <
  TData = Awaited<ReturnType<typeof getAvailabilityDatesByMonth>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  year: number,
  month: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailabilityDatesByMonth>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAvailabilityDatesByMonthQueryOptions(
    activityId,
    year,
    month,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra los terminos y condiciones de una actividad
 * @summary getTermsAndConditions
 */
export const getTermsAndConditions1 = (
  activityId: number,
  signal?: AbortSignal,
) => {
  return instance<ActivityTermsAndConditionsVm>({
    url: `/api/v1/activity/${activityId}/terms-and-conditions`,
    method: "GET",
    signal,
  });
};

export const getGetTermsAndConditions1QueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/terms-and-conditions`] as const;
};

export const getGetTermsAndConditions1QueryOptions = <
  TData = Awaited<ReturnType<typeof getTermsAndConditions1>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditions1>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTermsAndConditions1QueryKey(activityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTermsAndConditions1>>
  > = ({ signal }) => getTermsAndConditions1(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTermsAndConditions1>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTermsAndConditions1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTermsAndConditions1>>
>;
export type GetTermsAndConditions1QueryError = ErrorType<unknown>;

/**
 * @summary getTermsAndConditions
 */
export const useGetTermsAndConditions1 = <
  TData = Awaited<ReturnType<typeof getTermsAndConditions1>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditions1>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTermsAndConditions1QueryOptions(
    activityId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra los terminos y condiciones de una actividad
 * @summary getStartDateEndDate
 */
export const getStartDateEndDate = (
  activityId: number,
  signal?: AbortSignal,
) => {
  return instance<ActivityStartDateEndDateVm>({
    url: `/api/v1/activity/${activityId}/start-end-date`,
    method: "GET",
    signal,
  });
};

export const getGetStartDateEndDateQueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/start-end-date`] as const;
};

export const getGetStartDateEndDateQueryOptions = <
  TData = Awaited<ReturnType<typeof getStartDateEndDate>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStartDateEndDate>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStartDateEndDateQueryKey(activityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStartDateEndDate>>
  > = ({ signal }) => getStartDateEndDate(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStartDateEndDate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStartDateEndDateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStartDateEndDate>>
>;
export type GetStartDateEndDateQueryError = ErrorType<unknown>;

/**
 * @summary getStartDateEndDate
 */
export const useGetStartDateEndDate = <
  TData = Awaited<ReturnType<typeof getStartDateEndDate>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStartDateEndDate>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStartDateEndDateQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra la información de horarios de una actividad por mes
 * @summary getAvailabilityHoursByScheduleDateAndStartTime
 */
export const getAvailabilityHoursByScheduleDateAndStartTime = (
  activityId: number,
  scheduleId: number,
  date: string,
  startTime: string,
  signal?: AbortSignal,
) => {
  return instance<ScheduleHoursRangeVm>({
    url: `/api/v1/activity/${activityId}/schedule/${scheduleId}/date/${date}/start-at/${startTime}/details`,
    method: "GET",
    signal,
  });
};

export const getGetAvailabilityHoursByScheduleDateAndStartTimeQueryKey = (
  activityId: number,
  scheduleId: number,
  date: string,
  startTime: string,
) => {
  return [
    `/api/v1/activity/${activityId}/schedule/${scheduleId}/date/${date}/start-at/${startTime}/details`,
  ] as const;
};

export const getGetAvailabilityHoursByScheduleDateAndStartTimeQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAvailabilityHoursByScheduleDateAndStartTime>
  >,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  scheduleId: number,
  date: string,
  startTime: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getAvailabilityHoursByScheduleDateAndStartTime>
      >,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAvailabilityHoursByScheduleDateAndStartTimeQueryKey(
      activityId,
      scheduleId,
      date,
      startTime,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailabilityHoursByScheduleDateAndStartTime>>
  > = ({ signal }) =>
    getAvailabilityHoursByScheduleDateAndStartTime(
      activityId,
      scheduleId,
      date,
      startTime,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(activityId && scheduleId && date && startTime),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailabilityHoursByScheduleDateAndStartTime>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAvailabilityHoursByScheduleDateAndStartTimeQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAvailabilityHoursByScheduleDateAndStartTime>>
  >;
export type GetAvailabilityHoursByScheduleDateAndStartTimeQueryError =
  ErrorType<unknown>;

/**
 * @summary getAvailabilityHoursByScheduleDateAndStartTime
 */
export const useGetAvailabilityHoursByScheduleDateAndStartTime = <
  TData = Awaited<
    ReturnType<typeof getAvailabilityHoursByScheduleDateAndStartTime>
  >,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  scheduleId: number,
  date: string,
  startTime: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getAvailabilityHoursByScheduleDateAndStartTime>
      >,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetAvailabilityHoursByScheduleDateAndStartTimeQueryOptions(
      activityId,
      scheduleId,
      date,
      startTime,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra la descipcion de una actividad
 * @summary getLocation
 */
export const getLocation = (activityId: number, signal?: AbortSignal) => {
  return instance<ActivityAddressVm>({
    url: `/api/v1/activity/${activityId}/location`,
    method: "GET",
    signal,
  });
};

export const getGetLocationQueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/location`] as const;
};

export const getGetLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getLocation>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLocation>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLocationQueryKey(activityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocation>>> = ({
    signal,
  }) => getLocation(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLocation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLocation>>
>;
export type GetLocationQueryError = ErrorType<unknown>;

/**
 * @summary getLocation
 */
export const useGetLocation = <
  TData = Awaited<ReturnType<typeof getLocation>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLocation>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLocationQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Get Languages Activities
 * @summary getActivityLanguages
 */
export const getActivityLanguages = (
  activityId: number,
  signal?: AbortSignal,
) => {
  return instance<ActivityLanguage[]>({
    url: `/api/v1/activity/${activityId}/languages`,
    method: "GET",
    signal,
  });
};

export const getGetActivityLanguagesQueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/languages`] as const;
};

export const getGetActivityLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivityLanguages>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityLanguages>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActivityLanguagesQueryKey(activityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivityLanguages>>
  > = ({ signal }) => getActivityLanguages(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivityLanguages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActivityLanguagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivityLanguages>>
>;
export type GetActivityLanguagesQueryError = ErrorType<unknown>;

/**
 * @summary getActivityLanguages
 */
export const useGetActivityLanguages = <
  TData = Awaited<ReturnType<typeof getActivityLanguages>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getActivityLanguages>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetActivityLanguagesQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @deprecated
 * @summary isActivityFavorite
 */
export const getIsActivityFavorite = (
  activityId: number,
  signal?: AbortSignal,
) => {
  return instance<boolean>({
    url: `/api/v1/activity/${activityId}/is-favorite`,
    method: "GET",
    signal,
  });
};

export const getGetIsActivityFavoriteQueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/is-favorite`] as const;
};

export const getGetIsActivityFavoriteQueryOptions = <
  TData = Awaited<ReturnType<typeof getIsActivityFavorite>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIsActivityFavorite>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIsActivityFavoriteQueryKey(activityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIsActivityFavorite>>
  > = ({ signal }) => getIsActivityFavorite(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIsActivityFavorite>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIsActivityFavoriteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIsActivityFavorite>>
>;
export type GetIsActivityFavoriteQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary isActivityFavorite
 */
export const useGetIsActivityFavorite = <
  TData = Awaited<ReturnType<typeof getIsActivityFavorite>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIsActivityFavorite>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIsActivityFavoriteQueryOptions(
    activityId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra el detalle de una actividad
 * @summary getDetail
 */
export const getDetail = (activityId: number, signal?: AbortSignal) => {
  return instance<ActivityDetailVm>({
    url: `/api/v1/activity/${activityId}/detail-info`,
    method: "GET",
    signal,
  });
};

export const getGetDetailQueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/detail-info`] as const;
};

export const getGetDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getDetail>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDetail>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDetailQueryKey(activityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDetail>>> = ({
    signal,
  }) => getDetail(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDetail>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDetail>>
>;
export type GetDetailQueryError = ErrorType<unknown>;

/**
 * @summary getDetail
 */
export const useGetDetail = <
  TData = Awaited<ReturnType<typeof getDetail>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDetail>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDetailQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra la descipcion de una actividad
 * @summary getDescription
 */
export const getDescription = (activityId: number, signal?: AbortSignal) => {
  return instance<ActivityBasicInfoVm>({
    url: `/api/v1/activity/${activityId}/description`,
    method: "GET",
    signal,
  });
};

export const getGetDescriptionQueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/description`] as const;
};

export const getGetDescriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getDescription>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDescription>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDescriptionQueryKey(activityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDescription>>> = ({
    signal,
  }) => getDescription(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDescription>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDescriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDescription>>
>;
export type GetDescriptionQueryError = ErrorType<unknown>;

/**
 * @summary getDescription
 */
export const useGetDescription = <
  TData = Awaited<ReturnType<typeof getDescription>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDescription>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDescriptionQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra la información de horarios de una actividad por mes
 * @summary getAvailabilityHoursByDateAndStartTime
 */
export const getAvailabilityHoursByDateAndStartTime = (
  activityId: number,
  date: string,
  startTime: string,
  signal?: AbortSignal,
) => {
  return instance<AvailabilityHoursVm>({
    url: `/api/v1/activity/${activityId}/date/${date}/start-at/${startTime}/details`,
    method: "GET",
    signal,
  });
};

export const getGetAvailabilityHoursByDateAndStartTimeQueryKey = (
  activityId: number,
  date: string,
  startTime: string,
) => {
  return [
    `/api/v1/activity/${activityId}/date/${date}/start-at/${startTime}/details`,
  ] as const;
};

export const getGetAvailabilityHoursByDateAndStartTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailabilityHoursByDateAndStartTime>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  date: string,
  startTime: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailabilityHoursByDateAndStartTime>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAvailabilityHoursByDateAndStartTimeQueryKey(
      activityId,
      date,
      startTime,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailabilityHoursByDateAndStartTime>>
  > = ({ signal }) =>
    getAvailabilityHoursByDateAndStartTime(activityId, date, startTime, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(activityId && date && startTime),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailabilityHoursByDateAndStartTime>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAvailabilityHoursByDateAndStartTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailabilityHoursByDateAndStartTime>>
>;
export type GetAvailabilityHoursByDateAndStartTimeQueryError =
  ErrorType<unknown>;

/**
 * @summary getAvailabilityHoursByDateAndStartTime
 */
export const useGetAvailabilityHoursByDateAndStartTime = <
  TData = Awaited<ReturnType<typeof getAvailabilityHoursByDateAndStartTime>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  date: string,
  startTime: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailabilityHoursByDateAndStartTime>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAvailabilityHoursByDateAndStartTimeQueryOptions(
    activityId,
    date,
    startTime,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra la información de horarios de una actividad por mes
 * @summary getAvailabilityHoursByDate
 */
export const getAvailabilityHoursByDate = (
  activityId: number,
  date: string,
  signal?: AbortSignal,
) => {
  return instance<AvailabilityHoursVm>({
    url: `/api/v1/activity/${activityId}/date/${date}/hours-available`,
    method: "GET",
    signal,
  });
};

export const getGetAvailabilityHoursByDateQueryKey = (
  activityId: number,
  date: string,
) => {
  return [
    `/api/v1/activity/${activityId}/date/${date}/hours-available`,
  ] as const;
};

export const getGetAvailabilityHoursByDateQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailabilityHoursByDate>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  date: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailabilityHoursByDate>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAvailabilityHoursByDateQueryKey(activityId, date);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailabilityHoursByDate>>
  > = ({ signal }) => getAvailabilityHoursByDate(activityId, date, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(activityId && date),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailabilityHoursByDate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAvailabilityHoursByDateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailabilityHoursByDate>>
>;
export type GetAvailabilityHoursByDateQueryError = ErrorType<unknown>;

/**
 * @summary getAvailabilityHoursByDate
 */
export const useGetAvailabilityHoursByDate = <
  TData = Awaited<ReturnType<typeof getAvailabilityHoursByDate>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  date: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailabilityHoursByDate>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAvailabilityHoursByDateQueryOptions(
    activityId,
    date,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra los comentarios de una actividad
 * @summary getComments
 */
export const getComments = (
  activityId: number,
  params?: GetCommentsParams,
  signal?: AbortSignal,
) => {
  return instance<PageVmReservationFeedbackVm>({
    url: `/api/v1/activity/${activityId}/comments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCommentsQueryKey = (
  activityId: number,
  params?: GetCommentsParams,
) => {
  return [
    `/api/v1/activity/${activityId}/comments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getComments>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  params?: GetCommentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getComments>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCommentsQueryKey(activityId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getComments>>> = ({
    signal,
  }) => getComments(activityId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getComments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getComments>>
>;
export type GetCommentsQueryError = ErrorType<unknown>;

/**
 * @summary getComments
 */
export const useGetComments = <
  TData = Awaited<ReturnType<typeof getComments>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  params?: GetCommentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getComments>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCommentsQueryOptions(activityId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Busca actividades por la distancia en metros de un punto dado y por días de la semana que se encuentren en un horario de la actividad.
 * @summary publicAllInfo
 */
export const getAllActivityInfo = (
  activityId: number,
  params?: GetAllActivityInfoParams,
  signal?: AbortSignal,
) => {
  return instance<ActivityDetailGeoSearch>({
    url: `/api/v1/activity/${activityId}/all-info`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAllActivityInfoQueryKey = (
  activityId: number,
  params?: GetAllActivityInfoParams,
) => {
  return [
    `/api/v1/activity/${activityId}/all-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAllActivityInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllActivityInfo>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  params?: GetAllActivityInfoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAllActivityInfo>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllActivityInfoQueryKey(activityId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllActivityInfo>>
  > = ({ signal }) => getAllActivityInfo(activityId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllActivityInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllActivityInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllActivityInfo>>
>;
export type GetAllActivityInfoQueryError = ErrorType<unknown>;

/**
 * @summary publicAllInfo
 */
export const useGetAllActivityInfo = <
  TData = Awaited<ReturnType<typeof getAllActivityInfo>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  params?: GetAllActivityInfoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAllActivityInfo>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAllActivityInfoQueryOptions(
    activityId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary getAudiencePrices
 */
export const getAudienceActivePrices = (
  activityId: number,
  signal?: AbortSignal,
) => {
  return instance<ActivityAudienceActivePriceVm[]>({
    url: `/api/v1/activity/${activityId}/active-prices`,
    method: "GET",
    signal,
  });
};

export const getGetAudienceActivePricesQueryKey = (activityId: number) => {
  return [`/api/v1/activity/${activityId}/active-prices`] as const;
};

export const getGetAudienceActivePricesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudienceActivePrices>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAudienceActivePrices>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAudienceActivePricesQueryKey(activityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAudienceActivePrices>>
  > = ({ signal }) => getAudienceActivePrices(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAudienceActivePrices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAudienceActivePricesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAudienceActivePrices>>
>;
export type GetAudienceActivePricesQueryError = ErrorType<unknown>;

/**
 * @summary getAudiencePrices
 */
export const useGetAudienceActivePrices = <
  TData = Awaited<ReturnType<typeof getAudienceActivePrices>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAudienceActivePrices>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAudienceActivePricesQueryOptions(
    activityId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const search = (params?: SearchParams, signal?: AbortSignal) => {
  return instance<PageVmActivitySearchVm>({
    url: `/api/v1/activity/search`,
    method: "GET",
    params,
    signal,
  });
};

export const getSearchQueryKey = (params?: SearchParams) => {
  return [`/api/v1/activity/search`, ...(params ? [params] : [])] as const;
};

export const getSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof search>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof search>>> = ({
    signal,
  }) => search(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof search>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchQueryResult = NonNullable<Awaited<ReturnType<typeof search>>>;
export type SearchQueryError = ErrorType<unknown>;

export const useSearch = <
  TData = Awaited<ReturnType<typeof search>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Muestra la información de un horario especifico
 * @summary getScheduleDetail
 */
export const getScheduleDetail = (scheduleId: number, signal?: AbortSignal) => {
  return instance<CustomSchedule>({
    url: `/api/v1/activity/schedule/${scheduleId}`,
    method: "GET",
    signal,
  });
};

export const getGetScheduleDetailQueryKey = (scheduleId: number) => {
  return [`/api/v1/activity/schedule/${scheduleId}`] as const;
};

export const getGetScheduleDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getScheduleDetail>>,
  TError = ErrorType<unknown>,
>(
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScheduleDetail>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetScheduleDetailQueryKey(scheduleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getScheduleDetail>>
  > = ({ signal }) => getScheduleDetail(scheduleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!scheduleId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getScheduleDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetScheduleDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getScheduleDetail>>
>;
export type GetScheduleDetailQueryError = ErrorType<unknown>;

/**
 * @summary getScheduleDetail
 */
export const useGetScheduleDetail = <
  TData = Awaited<ReturnType<typeof getScheduleDetail>>,
  TError = ErrorType<unknown>,
>(
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScheduleDetail>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetScheduleDetailQueryOptions(scheduleId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Busca actividades por la distancia en metros de un punto dado y por días de la semana que se encuentren en un horario de la actividad.
 * @summary findByLocation
 */
export const findByLocation = (
  params?: FindByLocationParams,
  signal?: AbortSignal,
) => {
  return instance<ActivityDetailGeoSearch[]>({
    url: `/api/v1/activity/find/location`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindByLocationQueryKey = (params?: FindByLocationParams) => {
  return [
    `/api/v1/activity/find/location`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindByLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof findByLocation>>,
  TError = ErrorType<unknown>,
>(
  params?: FindByLocationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findByLocation>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindByLocationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findByLocation>>> = ({
    signal,
  }) => findByLocation(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findByLocation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindByLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof findByLocation>>
>;
export type FindByLocationQueryError = ErrorType<unknown>;

/**
 * @summary findByLocation
 */
export const useFindByLocation = <
  TData = Awaited<ReturnType<typeof findByLocation>>,
  TError = ErrorType<unknown>,
>(
  params?: FindByLocationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findByLocation>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindByLocationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Busca actividades por la distancia en metros de un punto dado y por días de la semana que se encuentren en un horario de la actividad.
 * @summary findByLocationAndDays
 */
export const findByLocationAndDays = (
  params?: FindByLocationAndDaysParams,
  signal?: AbortSignal,
) => {
  return instance<ActivityDetailGeoSearch[]>({
    url: `/api/v1/activity/find/location/days`,
    method: "GET",
    params,
    signal,
  });
};

export const getFindByLocationAndDaysQueryKey = (
  params?: FindByLocationAndDaysParams,
) => {
  return [
    `/api/v1/activity/find/location/days`,
    ...(params ? [params] : []),
  ] as const;
};

export const getFindByLocationAndDaysQueryOptions = <
  TData = Awaited<ReturnType<typeof findByLocationAndDays>>,
  TError = ErrorType<unknown>,
>(
  params?: FindByLocationAndDaysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findByLocationAndDays>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindByLocationAndDaysQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findByLocationAndDays>>
  > = ({ signal }) => findByLocationAndDays(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findByLocationAndDays>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindByLocationAndDaysQueryResult = NonNullable<
  Awaited<ReturnType<typeof findByLocationAndDays>>
>;
export type FindByLocationAndDaysQueryError = ErrorType<unknown>;

/**
 * @summary findByLocationAndDays
 */
export const useFindByLocationAndDays = <
  TData = Awaited<ReturnType<typeof findByLocationAndDays>>,
  TError = ErrorType<unknown>,
>(
  params?: FindByLocationAndDaysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findByLocationAndDays>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindByLocationAndDaysQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Indica si la actividad es favorita.
 * @summary isActivityFavorite
 */
export const isFavorite = (activityId: number, signal?: AbortSignal) => {
  return instance<boolean>({
    url: `/api/v1/activity/favorite/${activityId}/is-favorite`,
    method: "GET",
    signal,
  });
};

export const getIsFavoriteQueryKey = (activityId: number) => {
  return [`/api/v1/activity/favorite/${activityId}/is-favorite`] as const;
};

export const getIsFavoriteQueryOptions = <
  TData = Awaited<ReturnType<typeof isFavorite>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof isFavorite>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsFavoriteQueryKey(activityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isFavorite>>> = ({
    signal,
  }) => isFavorite(activityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!activityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof isFavorite>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type IsFavoriteQueryResult = NonNullable<
  Awaited<ReturnType<typeof isFavorite>>
>;
export type IsFavoriteQueryError = ErrorType<unknown>;

/**
 * @summary isActivityFavorite
 */
export const useIsFavorite = <
  TData = Awaited<ReturnType<typeof isFavorite>>,
  TError = ErrorType<unknown>,
>(
  activityId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof isFavorite>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getIsFavoriteQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Obtiene las actividades favoritas del viajero.
 * @deprecated
 * @summary getFavoriteTravelerActivity
 */
export const getFavoriteTravelerActivity = (
  params?: GetFavoriteTravelerActivityParams,
  signal?: AbortSignal,
) => {
  return instance<PageVmActivityDetailGeoSearch>({
    url: `/api/v1/activity/favorite-activity`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFavoriteTravelerActivityQueryKey = (
  params?: GetFavoriteTravelerActivityParams,
) => {
  return [
    `/api/v1/activity/favorite-activity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFavoriteTravelerActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavoriteTravelerActivity>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFavoriteTravelerActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFavoriteTravelerActivity>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFavoriteTravelerActivityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFavoriteTravelerActivity>>
  > = ({ signal }) => getFavoriteTravelerActivity(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavoriteTravelerActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFavoriteTravelerActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavoriteTravelerActivity>>
>;
export type GetFavoriteTravelerActivityQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary getFavoriteTravelerActivity
 */
export const useGetFavoriteTravelerActivity = <
  TData = Awaited<ReturnType<typeof getFavoriteTravelerActivity>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFavoriteTravelerActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFavoriteTravelerActivity>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFavoriteTravelerActivityQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Libera los lugares reservados durante el draft.
 * @summary releaseDraftSeats
 */
export const releaseDraftSeats = (
  id: number,
  params: ReleaseDraftSeatsParams,
) => {
  return instance<Success>({
    url: `/api/v1/reservation/schedule/${id}/release-draft`,
    method: "DELETE",
    params,
  });
};

export const getReleaseDraftSeatsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseDraftSeats>>,
    TError,
    { id: number; params: ReleaseDraftSeatsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releaseDraftSeats>>,
  TError,
  { id: number; params: ReleaseDraftSeatsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releaseDraftSeats>>,
    { id: number; params: ReleaseDraftSeatsParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return releaseDraftSeats(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseDraftSeatsMutationResult = NonNullable<
  Awaited<ReturnType<typeof releaseDraftSeats>>
>;

export type ReleaseDraftSeatsMutationError = ErrorType<unknown>;

/**
 * @summary releaseDraftSeats
 */
export const useReleaseDraftSeats = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseDraftSeats>>,
    TError,
    { id: number; params: ReleaseDraftSeatsParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof releaseDraftSeats>>,
  TError,
  { id: number; params: ReleaseDraftSeatsParams },
  TContext
> => {
  const mutationOptions = getReleaseDraftSeatsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Cancela la solicitud de factura del viajero.
 * @summary cancelInvoiceRequest
 */
export const cancelInvoiceRequest = (paymentId: number) => {
  return instance<Success>({
    url: `/api/v1/reservation/cancel/invoice-request/${paymentId}`,
    method: "DELETE",
  });
};

export const getCancelInvoiceRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelInvoiceRequest>>,
    TError,
    { paymentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelInvoiceRequest>>,
  TError,
  { paymentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelInvoiceRequest>>,
    { paymentId: number }
  > = (props) => {
    const { paymentId } = props ?? {};

    return cancelInvoiceRequest(paymentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelInvoiceRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelInvoiceRequest>>
>;

export type CancelInvoiceRequestMutationError = ErrorType<unknown>;

/**
 * @summary cancelInvoiceRequest
 */
export const useCancelInvoiceRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelInvoiceRequest>>,
    TError,
    { paymentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelInvoiceRequest>>,
  TError,
  { paymentId: number },
  TContext
> => {
  const mutationOptions = getCancelInvoiceRequestMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Elimina la información de un método de pago del usuario.
 * @summary deletePaymentMethod
 */
export const deletePaymentMethod = (id: number) => {
  return instance<Success>({
    url: `/api/v1/profile/payment-method/${id}`,
    method: "DELETE",
  });
};

export const getDeletePaymentMethodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePaymentMethod>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePaymentMethod>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePaymentMethod>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePaymentMethod(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePaymentMethod>>
>;

export type DeletePaymentMethodMutationError = ErrorType<unknown>;

/**
 * @summary deletePaymentMethod
 */
export const useDeletePaymentMethod = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePaymentMethod>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePaymentMethod>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeletePaymentMethodMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Elimina una actividad favorita de una lista específica.
 * @summary removeFavoriteActivityFromList
 */
export const removeFavoriteActivity = (activityId: number) => {
  return instance<Success>({
    url: `/api/v1/activity/favorite/remove/activity/${activityId}`,
    method: "DELETE",
  });
};

export const getRemoveFavoriteActivityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteActivity>>,
    TError,
    { activityId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFavoriteActivity>>,
  TError,
  { activityId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFavoriteActivity>>,
    { activityId: number }
  > = (props) => {
    const { activityId } = props ?? {};

    return removeFavoriteActivity(activityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFavoriteActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFavoriteActivity>>
>;

export type RemoveFavoriteActivityMutationError = ErrorType<unknown>;

/**
 * @summary removeFavoriteActivityFromList
 */
export const useRemoveFavoriteActivity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteActivity>>,
    TError,
    { activityId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeFavoriteActivity>>,
  TError,
  { activityId: number },
  TContext
> => {
  const mutationOptions = getRemoveFavoriteActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Elimina una actividad favorita de una lista específica.
 * @summary removeFavoriteActivityFromList
 */
export const removeFavoriteActivityFromList = (
  id: number,
  activityId: number,
) => {
  return instance<Success>({
    url: `/api/v1/activity/favorite/list/${id}/activity/${activityId}`,
    method: "DELETE",
  });
};

export const getRemoveFavoriteActivityFromListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteActivityFromList>>,
    TError,
    { id: number; activityId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFavoriteActivityFromList>>,
  TError,
  { id: number; activityId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFavoriteActivityFromList>>,
    { id: number; activityId: number }
  > = (props) => {
    const { id, activityId } = props ?? {};

    return removeFavoriteActivityFromList(id, activityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFavoriteActivityFromListMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFavoriteActivityFromList>>
>;

export type RemoveFavoriteActivityFromListMutationError = ErrorType<unknown>;

/**
 * @summary removeFavoriteActivityFromList
 */
export const useRemoveFavoriteActivityFromList = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteActivityFromList>>,
    TError,
    { id: number; activityId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeFavoriteActivityFromList>>,
  TError,
  { id: number; activityId: number },
  TContext
> => {
  const mutationOptions =
    getRemoveFavoriteActivityFromListMutationOptions(options);

  return useMutation(mutationOptions);
};
